import type { Variants } from '../types';

const metaDescriptionVariantTitles: Record<string, Variants> = {
	'/ca/tv-show/bridgerton/season-4': 'V1',
	'/ca/tv-show/fallout/season-2': 'V2',
	'/ca/tv-show/abandoned-engineering/season-12': 'V3',
	'/ca/tv-show/cross/season-2': 'V1',
	'/ca/tv-show/dtf-st-louis/season-1': 'V2',
	'/ca/tv-show/day-one/season-1': 'V3',
	'/ca/tv-show/crap-happens/season-1': 'V1',
	'/ca/tv-show/esa-noche/season-1': 'V2',
	'/ca/tv-show/9-1-1/season-9': 'V3',
	'/ca/tv-show/drops-of-god/season-2': 'V1',
	'/ca/tv-show/abbott-elementary/season-5': 'V2',
	'/ca/tv-show/dark-winds/season-4': 'V3',
	'/ca/tv-show/dynasty-the-murdochs/season-1': 'V1',
	'/ca/tv-show/agents-of-mystery/season-2': 'V2',
	'/ca/tv-show/cia/season-1': 'V3',
	'/ca/tv-show/georgie-and-mandys-first-marriage/season-2': 'V1',
	'/ca/tv-show/cross/season-1': 'V2',
	'/ca/tv-show/age-of-attraction/season-1': 'V3',
	'/ca/tv-show/blue-therapy/season-1': 'V1',
	'/ca/tv-show/fbi/season-8': 'V2',
	'/ca/tv-show/9-1-1-nashville/season-1': 'V3',
	'/ca/tv-show/doc/season-2': 'V1',
	'/ca/tv-show/beastars/season-3': 'V2',
	'/ca/tv-show/euphoria/season-1': 'V3',
	'/ca/tv-show/canada-shore/season-1': 'V1',
	'/ca/tv-show/being-gordon-ramsay/season-1': 'V2',
	'/ca/tv-show/chicago-p-d/season-13': 'V3',
	'/ca/tv-show/all-her-fault/season-1': 'V1',
	'/ca/tv-show/chicago-fire/season-14': 'V2',
	'/ca/tv-show/blackbeard-2006/season-1': 'V3',
	'/ca/tv-show/el-asesino-de-tiktok/season-1': 'V1',
	'/ca/tv-show/death-in-paradise/season-15': 'V2',
	'/ca/tv-show/fire-country/season-4': 'V3',
	'/ca/tv-show/dmv/season-1': 'V1',
	'/ca/tv-show/bridgerton/season-3': 'V2',
	'/ca/tv-show/alien/season-1': 'V3',
	'/ca/tv-show/bridgerton/season-1': 'V1',
	'/ca/tv-show/gen-v/season-2': 'V2',
	'/ca/tv-show/cold-case-files-dead-west/season-1': 'V3',
	'/ca/tv-show/daredevil-born-again/season-1': 'V1',
	'/ca/tv-show/game-of-thrones/season-1': 'V2',
	'/ca/tv-show/chicago-med/season-11': 'V3',
	'/ca/tv-show/fargo/season-5': 'V1',
	'/ca/tv-show/boston-blue/season-1': 'V2',
	'/ca/tv-show/foundation/season-3': 'V3',
	'/ca/tv-show/dark-winds/season-3': 'V1',
	'/ca/tv-show/frieren-beyond-journeys-end/season-2': 'V2',
	'/ca/tv-show/chicago-fire/season-13': 'V3',
	'/ca/tv-show/dark-winds/season-1': 'V1',
	'/ca/tv-show/fire-force/season-3': 'V2',
	'/ca/tv-show/all-creatures-great-and-small-2020/season-6': 'V3',
	'/ca/tv-show/bridgerton/season-2': 'V1',
	'/ca/tv-show/fringe/season-1': 'V2',
	'/ca/tv-show/dune-the-sisterhood/season-1': 'V3',
	'/ca/tv-show/fatal-seduction/season-3': 'V1',
	'/ca/tv-show/90-day-the-single-life/season-5': 'V2',
	'/ca/tv-show/friends/season-1': 'V3',
	'/ca/tv-show/dexter/season-1': 'V1',
	'/ca/tv-show/dare-you-to-death/season-1': 'V2',
	'/ca/tv-show/falling-skies/season-2': 'V3',
	'/ca/tv-show/babylon-5/season-1': 'V1',
	'/ca/tv-show/dark-moon-the-blood-altar/season-1': 'V2',
	'/ca/tv-show/from/season-3': 'V3',
	'/ca/tv-show/1923/season-2': 'V1',
	'/ca/tv-show/er/season-1': 'V2',
	'/ca/tv-show/andor/season-2': 'V3',
	'/ca/tv-show/breaking-bad/season-4': 'V1',
	'/ca/tv-show/department-q/season-1': 'V2',
	'/ca/tv-show/breaking-bad/season-1': 'V3',
	'/ca/tv-show/animal-kingdom/season-2': 'V1',
	'/ca/tv-show/extracted/season-2': 'V2',
	'/ca/tv-show/doc/season-1': 'V3',
	'/ca/tv-show/batman-the-animated-series/season-1': 'V1',
	'/ca/tv-show/gangs-of-london/season-3': 'V2',
	'/ca/tv-show/dark-winds/season-2': 'V3',
	'/ca/tv-show/doctor-who-2023/season-2': 'V1',
	'/ca/tv-show/expedition-x/season-11': 'V2',
	'/ca/tv-show/chief-of-war/season-1': 'V3',
	'/ca/tv-show/falling-skies/season-3': 'V1',
	'/ca/tv-show/for-all-mankind/season-2': 'V2',
	'/ca/tv-show/chernobyl/season-1': 'V3',
	'/ca/tv-show/1883/season-1': 'V1',
	'/ca/tv-show/emergencia-radioativa/season-1': 'V2',
	'/ca/tv-show/fargo/season-1': 'V3',
	'/ca/tv-show/for-all-mankind/season-4': 'V1',
	'/ca/tv-show/dexter-resurrection/season-1': 'V2',
	'/ca/tv-show/dragon-ball/season-1': 'V3',
	'/ca/tv-show/american-monster-abuse-of-power/season-1': 'V1',
	'/ca/tv-show/doctor-who/season-1': 'V2',
	'/ca/tv-show/father-brown/season-13': 'V3',
	'/ca/tv-show/animal-kingdom/season-3': 'V1',
	'/ca/tv-show/90-day-fiance-before-the-90-days/season-8': 'V2',
	'/ca/tv-show/breaking-bad/season-5': 'V3',
	'/ca/tv-show/adolescence-2025/season-1': 'V1',
	'/ca/tv-show/drommeren/season-1': 'V2',
	'/ca/tv-show/fullmetal-alchemist-brotherhood/season-1': 'V3',
	'/ca/tv-show/dexter-original-sin/season-1': 'V1',
	'/ca/tv-show/game-of-thrones/season-3': 'V2',
	'/ca/tv-show/breaking-bad/season-3': 'V3',
	'/ca/tv-show/alice-in-borderland/season-3': 'V1',
	'/ca/tv-show/demon-slayer-kimetsu-no-yaiba/season-4': 'V2',
	'/ca/tv-show/black-clover/season-1': 'V3',
	'/ca/tv-show/evil/season-4': 'V1',
	'/ca/tv-show/charlottes-web/season-1': 'V2',
	'/ca/tv-show/fargo/season-2': 'V3',
	'/ca/tv-show/blue-lights/season-3': 'V1',
	'/ca/tv-show/chicago-fire/season-12': 'V2',
	'/ca/tv-show/dark/season-1': 'V3',
	'/ca/tv-show/en-el-barro/season-1': 'V1',
	'/ca/tv-show/bobs-burgers/season-16': 'V2',
	'/ca/tv-show/england-from-the-fall-of-rome-to-the-norman-conquest/season-1': 'V3',
	'/ca/tv-show/dexter-new-blood/season-1': 'V1',
	'/ca/tv-show/attack-on-titan/season-3': 'V2',
	'/ca/tv-show/canadas-drag-race/season-6': 'V3',
	'/ca/tv-show/dexter/season-3': 'V1',
	'/ca/tv-show/breaking-bad/season-2': 'V2',
	'/ca/tv-show/death-note/season-1': 'V3',
	'/ca/tv-show/dirty-rotten-scandals/season-1': 'V1',
	'/ca/tv-show/3-body-problem/season-1': 'V2',
	'/ca/tv-show/game-of-thrones/season-6': 'V3',
	'/ca/tv-show/fringe/season-2': 'V1',
	'/ca/tv-show/andor/season-1': 'V2',
	'/ca/tv-show/2-broke-girls/season-1': 'V3',
	'/ca/tv-show/anderson-spider-silva/season-1': 'V1',
	'/ca/tv-show/battlestar-galactica/season-1': 'V2',
	'/ca/tv-show/black-clover/season-2': 'V3',
	'/ca/tv-show/bookish/season-1': 'V1',
	'/ca/tv-show/a-classic-spy/season-1': 'V2',
	'/ca/tv-show/foundation/season-2': 'V3',
	'/ca/tv-show/fear-factor-house-of-fear/season-1': 'V1',
	'/ca/tv-show/finding-her-edge/season-1': 'V2',
	'/ca/tv-show/banshee/season-1': 'V3',
	'/ca/tv-show/animal-kingdom/season-5': 'V1',
	'/ca/tv-show/astrid-et-raphaelle/season-5': 'V2',
	'/ca/tv-show/dark/season-2': 'V3',
	'/ca/tv-show/criminal-minds/season-1': 'V1',
	'/ca/tv-show/for-all-mankind/season-1': 'V2',
	'/ca/tv-show/game-of-thrones/season-5': 'V3',
	'/ca/tv-show/band-of-brothers/season-1': 'V1',
	'/ca/tv-show/game-of-thrones/season-7': 'V2',
	'/ca/tv-show/can-this-love-be-translated/season-1': 'V3',
	'/ca/tv-show/a-thousand-blows/season-1': 'V1',
	'/ca/tv-show/beef/season-1': 'V2',
	'/ca/tv-show/emily-in-paris/season-5': 'V3',
	'/ca/tv-show/animal-kingdom/season-4': 'V1',
	'/ca/tv-show/attack-on-titan/season-4': 'V2',
	'/ca/tv-show/born-to-bowl/season-1': 'V3',
	'/ca/tv-show/arcane/season-1': 'V1',
	'/ca/tv-show/downton-abbey/season-1': 'V2',
	'/ca/tv-show/dark-matter-2024/season-1': 'V3',
	'/ca/tv-show/dragon-ball-z-1989/season-1': 'V1',
	'/ca/tv-show/chicago-fire/season-1': 'V2',
	'/ca/tv-show/forever/season-1': 'V3',
	'/ca/tv-show/chicago-p-d/season-11': 'V1',
	'/ca/tv-show/1000-lb-sisters/season-8': 'V2',
	'/ca/tv-show/bridgerton-young-queen-charlotte-spinoff/season-1': 'V3',
	'/ca/tv-show/formula-1-drive-to-survive/season-1': 'V1',
	'/ca/tv-show/arrested-development/season-1': 'V2',
	'/ca/tv-show/american-horror-story/season-12': 'V3',
	'/ca/tv-show/gangs-of-london/season-1': 'V1',
	'/ca/tv-show/black-sails/season-1': 'V2',
	'/ca/tv-show/demon-slayer-kimetsu-no-yaiba/season-3': 'V3',
	'/ca/tv-show/9-1-1/season-1': 'V1',
	'/ca/tv-show/down-cemetery-road/season-1': 'V2',
	'/ca/tv-show/attack-on-titan/season-2': 'V3',
	'/ca/tv-show/fleabag/season-1': 'V1',
	'/ca/tv-show/better-call-saul/season-4': 'V2',
	'/ca/tv-show/better-call-saul/season-3': 'V3',
	'/ca/tv-show/avatar-the-last-airbender/season-1': 'V1',
	'/ca/tv-show/f4-thailand-boys-over-flowers/season-1': 'V2',
	'/ca/tv-show/blue-lights/season-1': 'V3',
	'/ca/tv-show/formula-1-drive-to-survive/season-6': 'V1',
	'/ca/tv-show/dawsons-creek/season-1': 'V2',
	'/ca/tv-show/abbott-elementary/season-1': 'V3',
	'/ca/tv-show/black-bird/season-1': 'V1',
	'/ca/tv-show/chained-soldier/season-2': 'V2',
	'/ca/tv-show/dead-account/season-1': 'V3',
	'/ca/tv-show/bones/season-2': 'V1',
	'/ca/tv-show/cobra-kai/season-6': 'V2',
	'/ca/tv-show/devil-in-disguise-john-wayne-gacy/season-1': 'V3',
	'/ca/tv-show/black-mirror/season-3': 'V1',
	'/ca/tv-show/alice-in-borderland/season-1': 'V2',
	'/ca/tv-show/fbi-most-wanted/season-6': 'V3',
	'/ca/tv-show/dexter/season-4': 'V1',
	'/ca/tv-show/ballard/season-1': 'V2',
	'/ca/tv-show/and-just-like-that/season-3': 'V3',
	'/ca/tv-show/elsbeth/season-2': 'V1',
	'/ca/tv-show/everwood/season-1': 'V2',
	'/ca/tv-show/evil-lives-here/season-19': 'V3',
	'/ca/tv-show/alf/season-1': 'V1',
	'/ca/tv-show/alone/season-11': 'V2',
	'/ca/tv-show/arrow/season-1': 'V3',
	'/ca/tv-show/a-spy-among-friends/season-1': 'V1',
	'/ca/tv-show/absentia/season-2': 'V2',
	'/ca/tv-show/beyond-paradise/season-3': 'V3',
	'/ca/tv-show/boruto-naruto-next-generations/season-1': 'V1',
	'/ca/tv-show/fate-strange-fake/season-1': 'V2',
	'/ca/tv-show/all-creatures-great-and-small-2020/season-1': 'V3',
	'/ca/tv-show/anne-rices-mayfair-witches/season-1': 'V1',
	'/ca/tv-show/brilliant-minds/season-2': 'V2',
	'/ca/tv-show/dexter/season-6': 'V3',
	'/ca/tv-show/beast-games/season-1': 'V1',
	'/ca/tv-show/evil-lives-here/season-16': 'V2',
	'/ca/tv-show/derry-girls/season-1': 'V3',
	'/ca/tv-show/american-horror-story/season-1': 'V1',
	'/ca/tv-show/chicago-fire/season-11': 'V2',
	'/ca/tv-show/el-eternauta/season-1': 'V3',
	'/ca/tv-show/georgie-and-mandys-first-marriage/season-1': 'V1',
	'/ca/tv-show/agatha-christies-poirot/season-1': 'V2',
	'/ca/tv-show/ben-10/season-1': 'V3',
	'/ca/tv-show/farzi/season-1': 'V1',
	'/ca/tv-show/from/season-2': 'V2',
	'/ca/tv-show/call-the-midwife/season-14': 'V3',
	'/ca/tv-show/chicago-med/season-10': 'V1',
	'/ca/tv-show/evil/season-2': 'V2',
	'/ca/tv-show/dorohedoro/season-1': 'V3',
	'/ca/tv-show/film-theory/season-6': 'V1',
	'/ca/tv-show/cardinal/season-1': 'V2',
	'/ca/tv-show/bluelock/season-1': 'V3',
	'/ca/tv-show/baylen-out-loud/season-2': 'V1',
	'/ca/tv-show/black-mirror/season-4': 'V2',
	'/ca/tv-show/dexter/season-5': 'V3',
	'/ca/tv-show/game-of-thrones/season-4': 'V1',
	'/ca/tv-show/asia-2024/season-1': 'V2',
	'/ca/tv-show/chained-soldier/season-1': 'V3',
	'/ca/tv-show/formula-1-drive-to-survive/season-4': 'V1',
	'/ca/tv-show/1923/season-1': 'V2',
	'/ca/tv-show/death-in-paradise/season-14': 'V3',
	'/ca/tv-show/arcane/season-2': 'V1',
	'/ca/tv-show/fringe/season-3': 'V2',
	'/ca/tv-show/fbi-most-wanted/season-2': 'V3',
	'/ca/tv-show/fbi/season-1': 'V1',
	'/ca/tv-show/demon-slayer-kimetsu-no-yaiba/season-2': 'V2',
	'/ca/tv-show/game-of-thrones/season-8': 'V3',
	'/ca/tv-show/elementary/season-1': 'V1',
	'/ca/tv-show/future-man/season-1': 'V2',
	'/ca/tv-show/formula-1-drive-to-survive/season-5': 'V3',
	'/ca/tv-show/criminal-minds/season-17': 'V1',
	'/ca/tv-show/billions/season-1': 'V2',
	'/ca/tv-show/bleach/season-1': 'V3',
	'/ca/tv-show/brilliant-minds/season-1': 'V1',
	'/ca/tv-show/air-disasters/season-4': 'V2',
	'/ca/tv-show/9-1-1/season-2': 'V3',
	'/ca/tv-show/beverly-hillbillies/season-1': 'V1',
	'/ca/tv-show/deadwood/season-1': 'V2',
	'/ca/tv-show/9-1-1/season-7': 'V3',
	'/ca/tv-show/boardwalk-empire/season-1': 'V1',
	'/ca/tv-show/an-adventurers-daily-grind-at-age-29/season-1': 'V2',
	'/ca/tv-show/all-creatures-great-and-small-2020/season-5': 'V3',
	'/ca/tv-show/all-the-queens-men/season-4': 'V1',
	'/ca/tv-show/criminal-minds/season-18': 'V2',
	'/ca/tv-show/elsbeth/season-1': 'V3',
	'/ca/tv-show/conversations-with-friends/season-1': 'V1',
	'/ca/tv-show/dead-like-me/season-1': 'V2',
	'/ca/tv-show/fbi/season-4': 'V3',
	'/ca/tv-show/fire-country/season-2': 'V1',
	'/ca/tv-show/camelot/season-1': 'V2',
	'/ca/tv-show/doom-patrol/season-1': 'V3',
	'/ca/tv-show/dr-stone/season-4': 'V1',
	'/ca/tv-show/chicago-med/season-8': 'V2',
	'/ca/tv-show/criminal-minds/season-2': 'V3',
	'/ca/tv-show/countdown/season-1': 'V1',
	'/ca/tv-show/desperate-housewives/season-1': 'V2',
	'/ca/tv-show/bad-monkey/season-1': 'V3',
	'/ca/tv-show/barry/season-1': 'V1',
	'/ca/tv-show/american-horror-story/season-2': 'V2',
	'/ca/tv-show/chicago-p-d/season-1': 'V3',
	'/ca/tv-show/all-the-sins/season-1': 'V1',
	'/ca/tv-show/columbo/season-1': 'V2',
	'/ca/tv-show/fbi/season-6': 'V3',
	'/ca/tv-show/anne-rices-mayfair-witches/season-2': 'V1',
	'/ca/tv-show/english-teacher/season-2': 'V2',
	'/ca/tv-show/gabbys-dollhouse/season-13': 'V3',
	'/ca/tv-show/everwood/season-2': 'V1',
	'/ca/tv-show/chicago-med/season-3': 'V2',
	'/ca/tv-show/chicago-p-d/season-4': 'V3',
	'/ca/tv-show/fire-country/season-1': 'V1',
	'/ca/tv-show/fringe/season-4': 'V2',
	'/ca/tv-show/bosch/season-1': 'V3',
	'/ca/tv-show/brooklyn-nine-nine/season-8': 'V1',
	'/ca/tv-show/fringe/season-5': 'V2',
	'/ca/tv-show/c-b-strike-2017/season-6': 'V3',
	'/ca/tv-show/american-gods/season-3': 'V1',
	'/ca/tv-show/formula-1-drive-to-survive/season-2': 'V2',
	'/ca/tv-show/er/season-2': 'V3',
	'/ca/tv-show/dispatches-from-elsewhere/season-1': 'V1',
	'/ca/tv-show/alex-hugo/season-1': 'V2',
	'/ca/tv-show/bosch-legacy/season-3': 'V3',
	'/ca/tv-show/all-creatures-great-and-small-2020/season-4': 'V1',
	'/ca/tv-show/big-little-lies/season-1': 'V2',
	'/ca/tv-show/broadchurch/season-1': 'V3',
	'/ca/tv-show/alex-rider/season-3': 'V1',
	'/ca/tv-show/blue-exorcist/season-1': 'V2',
	'/ca/tv-show/2-broke-girls/season-6': 'V3',
	'/ca/tv-show/doctor-who/season-5': 'V1',
	'/ca/tv-show/bones/season-5': 'V2',
	'/ca/tv-show/blanca/season-1': 'V3',
	'/ca/tv-show/criminal-minds/season-6': 'V1',
	'/ca/tv-show/american-horror-story/season-3': 'V2',
	'/ca/tv-show/aspirants/season-3': 'V3',
	'/ca/tv-show/chicago-p-d/season-10': 'V1',
	'/ca/tv-show/blindspot/season-2': 'V2',
	'/ca/tv-show/csi-crime-scene-investigation/season-1': 'V3',
	'/ca/tv-show/dating-naked-uk/season-1': 'V1',
	'/ca/tv-show/9-1-1/season-5': 'V2',
	'/ca/tv-show/blindspot/season-1': 'V3',
	'/ca/tv-show/domino-day-lone-witch/season-1': 'V1',
	'/ca/tv-show/empathie/season-1': 'V2',
	'/ca/tv-show/cowboy-bebop/season-1': 'V3',
	'/ca/tv-show/abbott-elementary/season-2': 'V1',
	'/ca/tv-show/all-creatures-great-and-small-2020/season-3': 'V2',
	'/ca/tv-show/fighting-spirit/season-1': 'V3',
	'/ca/tv-show/12-monkeys/season-1': 'V1',
	'/ca/tv-show/couples-therapy-2019/season-1': 'V2',
	'/ca/tv-show/dawsons-creek/season-2': 'V3',
	'/ca/tv-show/air-disasters/season-26': 'V1',
	'/ca/tv-show/a-d-the-bible-continues/season-1': 'V2',
	'/ca/tv-show/all-of-us-are-dead/season-1': 'V3',
	'/ca/tv-show/big-mouth-2022/season-1': 'V1',
	'/ca/tv-show/film-club/season-1': 'V2',
	'/ca/tv-show/blue-bloods/season-13': 'V3',
	'/ca/tv-show/call-the-midwife/season-1': 'V1',
	'/ca/tv-show/baki/season-3': 'V2',
	'/ca/tv-show/bad-sisters/season-2': 'V3',
	'/ca/tv-show/blue-bloods/season-14': 'V1',
	'/ca/tv-show/doom-patrol/season-4': 'V2',
	'/ca/tv-show/critical-role-the-legend-of-vox-machina/season-3': 'V3',
	'/ca/tv-show/crash-landing-on-you/season-1': 'V1',
	'/ca/tv-show/black-mirror/season-5': 'V2',
	'/ca/tv-show/adventure-time-fionna-and-cake/season-2': 'V3',
	'/ca/tv-show/chicago-fire/season-4': 'V1',
	'/ca/tv-show/days-of-our-lives/season-61': 'V2',
	'/ca/tv-show/friends/season-3': 'V3',
	'/ca/tv-show/detectorists/season-1': 'V1',
	'/ca/tv-show/american-gods/season-1': 'V2',
	'/ca/tv-show/doc-in-your-hands/season-1': 'V3',
	'/ca/tv-show/american-idol-the-search-for-a-superstar/season-24': 'V1',
	'/ca/tv-show/dead-like-me/season-2': 'V2',
	'/ca/tv-show/chicago-med/season-2': 'V3',
	'/ca/tv-show/astrid-et-raphaelle/season-1': 'V1',
	'/ca/tv-show/doctor-who-2023/season-1': 'V2',
	'/ca/tv-show/family-law-2021/season-4': 'V3',
	'/ca/tv-show/2-broke-girls/season-3': 'V1',
	'/ca/tv-show/ghost-whisperer/season-1': 'V2',
	'/ca/tv-show/de-viaje-con-los-derbez/season-1': 'V3',
	'/ca/tv-show/clarice/season-1': 'V1',
	'/ca/tv-show/castle/season-5': 'V2',
	'/ca/tv-show/1899/season-1': 'V3',
	'/ca/tv-show/doctor-foster/season-1': 'V1',
	'/ca/tv-show/castle-rock/season-1': 'V2',
	'/ca/tv-show/call-of-the-night/season-2': 'V3',
	'/ca/tv-show/2-broke-girls/season-2': 'V1',
	'/ca/tv-show/american-monster/season-13': 'V2',
	'/ca/tv-show/castle/season-1': 'V3',
	'/ca/tv-show/doctor-who/season-3': 'V1',
	'/ca/tv-show/bad-sisters/season-1': 'V2',
	'/ca/tv-show/angel-flight/season-1': 'V3',
	'/ca/tv-show/earth-abides/season-1': 'V1',
	'/ca/tv-show/disclaimer/season-1': 'V2',
	'/ca/tv-show/criminal-minds/season-4': 'V3',
	'/ca/tv-show/cosmos-a-spacetime-odyssey/season-1': 'V1',
	'/ca/tv-show/curb-your-enthusiasm/season-1': 'V2',
	'/ca/tv-show/free-bert/season-1': 'V3',
	'/ca/tv-show/alert-missing-persons-unit/season-3': 'V1',
	'/ca/tv-show/allegiance-2024/season-3': 'V2',
	'/ca/tv-show/beverly-hills-90210/season-1': 'V3',
	'/ca/tv-show/africa/season-1': 'V1',
	'/ca/tv-show/chicago-fire/season-10': 'V2',
	'/ca/tv-show/accused-2023/season-1': 'V3',
	'/ca/tv-show/genius/season-1': 'V1',
	'/ca/tv-show/cashero/season-1': 'V2',
	'/ca/tv-show/friends/season-5': 'V3',
	'/ca/tv-show/downton-abbey/season-2': 'V1',
	'/ca/tv-show/deaths-game/season-1': 'V2',
	'/ca/tv-show/american-horror-story/season-11': 'V3',
	'/ca/tv-show/buffy-the-vampire-slayer/season-1': 'V1',
	'/ca/tv-show/bones/season-9': 'V2',
	'/ca/tv-show/everwood/season-3': 'V3',
	'/ca/tv-show/billions/season-2': 'V1',
	'/ca/tv-show/brooklyn-nine-nine/season-3': 'V2',
	'/ca/tv-show/fellow-travelers/season-1': 'V3',
	'/ca/tv-show/code-of-silence/season-1': 'V1',
	'/ca/tv-show/blue-bloods/season-1': 'V2',
	'/ca/tv-show/9-1-1-lone-star/season-1': 'V3',
	'/ca/tv-show/fauda/season-1': 'V1',
	'/ca/tv-show/fbi/season-2': 'V2',
	'/ca/tv-show/cold-case/season-1': 'V3',
	'/ca/tv-show/desperate-housewives/season-2': 'V1',
	'/ca/tv-show/american-horror-story/season-5': 'V2',
	'/ca/tv-show/bonappetit-your-majesty/season-1': 'V3',
	'/ca/tv-show/firebug/season-1': 'V1',
	'/ca/tv-show/full-house/season-1': 'V2',
	'/ca/tv-show/ar-y-ffin/season-1': 'V3',
	'/ca/tv-show/arrow/season-4': 'V1',
	'/ca/tv-show/doctor-who/season-4': 'V2',
	'/ca/tv-show/c-b-strike-2017/season-5': 'V3',
	'/ca/tv-show/devil-may-cry/season-1': 'V1',
	'/ca/tv-show/9-1-1/season-4': 'V2',
	'/ca/tv-show/emily-in-paris/season-1': 'V3',
	'/ca/tv-show/billionaires-bunker/season-1': 'V1',
	'/ca/tv-show/a-discovery-of-witches/season-2': 'V2',
	'/ca/tv-show/brooklyn-nine-nine/season-6': 'V3',
	'/ca/tv-show/frank-herberts-children-of-dune/season-1': 'V1',
	'/ca/tv-show/genie-make-a-wish/season-1': 'V2',
	'/ca/tv-show/chicago-p-d/season-5': 'V3',
	'/ca/tv-show/castle/season-6': 'V1',
	'/ca/tv-show/bosch-legacy/season-2': 'V2',
	'/ca/tv-show/bosch-legacy/season-1': 'V3',
	'/ca/tv-show/banshee/season-3': 'V1',
	'/ca/tv-show/family-law-2021/season-3': 'V2',
	'/ca/tv-show/death-in-paradise/season-13': 'V3',
	'/ca/tv-show/devs/season-1': 'V1',
	'/ca/tv-show/accident-suicide-or-murder/season-6': 'V2',
	'/ca/tv-show/community/season-2': 'V3',
	'/ca/tv-show/doctor-who/season-13': 'V1',
	'/ca/tv-show/deleting-me-chain-of-revenge/season-1': 'V2',
	'/ca/tv-show/avatar-the-last-airbender-0/season-1': 'V3',
	'/ca/tv-show/blue-bloods/season-12': 'V1',
	'/ca/tv-show/babylon-5/season-2': 'V2',
	'/ca/tv-show/alone/season-1': 'V3',
	'/ca/tv-show/digimon-digital-monsters/season-1': 'V1',
	'/ca/tv-show/family-guy/season-22': 'V2',
	'/ca/tv-show/avatar-the-last-airbender/season-3': 'V3',
	'/ca/tv-show/arifureta-from-commonplace-to-worlds-strongest/season-3': 'V1',
	'/ca/tv-show/elementary/season-2': 'V2',
	'/ca/tv-show/2-broke-girls/season-4': 'V3',
	'/ca/tv-show/elite/season-1': 'V1',
	'/ca/tv-show/cheers/season-1': 'V2',
	'/ca/tv-show/friends/season-7': 'V3',
	'/ca/tv-show/gangs-of-london/season-2': 'V1',
	'/ca/tv-show/american-horror-story/season-6': 'V2',
	'/ca/tv-show/dcs-legends-of-tomorrow/season-1': 'V3',
	'/ca/tv-show/dragon-ball-daima/season-1': 'V1',
	'/ca/tv-show/fear-the-walking-dead/season-2': 'V2',
	'/ca/tv-show/cobra-kai/season-1': 'V3',
	'/ca/tv-show/criminal-minds/season-5': 'V1',
	'/ca/tv-show/chouchou/season-1': 'V2',
	'/ca/tv-show/fbi-most-wanted/season-5': 'V3',
	'/ca/tv-show/desperate-housewives/season-3': 'V1',
	'/ca/tv-show/bones/season-11': 'V2',
	'/ca/tv-show/dalgliesh-2021/season-2': 'V3',
	'/ca/tv-show/downton-abbey/season-6': 'V1',
	'/ca/tv-show/friends/season-10': 'V2',
	'/ca/tv-show/bones/season-7': 'V3',
	'/ca/tv-show/american-horror-story/season-7': 'V1',
	'/ca/tv-show/family-guy/season-21': 'V2',
	'/ca/tv-show/criminal-minds/season-3': 'V3',
	'/ca/tv-show/extra-ordinary-you/season-1': 'V1',
	'/ca/tv-show/call-the-midwife/season-6': 'V2',
	'/ca/tv-show/9-1-1-lone-star/season-5': 'V3',
	'/ca/tv-show/cash-queens/season-1': 'V1',
	'/ca/tv-show/broadchurch/season-3': 'V2',
	'/ca/tv-show/all-creatures-great-and-small-2020/season-2': 'V3',
	'/ca/tv-show/dickinson/season-1': 'V1',
	'/ca/tv-show/fubar/season-2': 'V2',
	'/ca/tv-show/a-good-girls-guide-to-murder/season-1': 'V3',
	'/ca/tv-show/dan-da-dan/season-1': 'V1',
	'/ca/tv-show/chicago-fire/season-2': 'V2',
	'/ca/tv-show/billions/season-6': 'V3',
	'/ca/tv-show/alchemy-of-souls/season-1': 'V1',
	'/ca/tv-show/american-horror-story/season-9': 'V2',
	'/ca/tv-show/dr-stone/season-1': 'V3',
	'/ca/tv-show/doctor-who/season-12': 'V1',
	'/ca/tv-show/billions/season-7': 'V2',
	'/ca/tv-show/berlin/season-1': 'V3',
	'/ca/tv-show/behind-her-eyes/season-1': 'V1',
	'/ca/tv-show/delicious-in-dungeon/season-1': 'V2',
	'/ca/tv-show/fbi-international/season-4': 'V3',
	'/ca/tv-show/chicago-p-d/season-6': 'V1',
	'/ca/tv-show/doc-martin/season-1': 'V2',
	'/ca/tv-show/bodies-2023/season-1': 'V3',
	'/ca/tv-show/friends/season-4': 'V1',
	'/ca/tv-show/brassic/season-6': 'V2',
	'/ca/tv-show/bosch/season-7': 'V3',
	'/ca/tv-show/for-the-love-of-dilfs/season-2': 'V1',
	'/ca/tv-show/arrow/season-2': 'V2',
	'/ca/tv-show/bluey/season-1': 'V3',
	'/ca/tv-show/a-murder-at-the-end-of-the-world/season-1': 'V1',
	'/ca/tv-show/chicago-p-d/season-9': 'V2',
	'/ca/tv-show/downton-abbey/season-4': 'V3',
	'/ca/tv-show/emmerdale/season-55': 'V1',
	'/ca/tv-show/fear-the-walking-dead/season-4': 'V2',
	'/ca/tv-show/chicago-fire/season-9': 'V3',
	'/ca/tv-show/chicago-med/season-4': 'V1',
	'/ca/tv-show/c-b-strike-2017/season-3': 'V2',
	'/ca/tv-show/bojack-horseman/season-5': 'V3',
	'/ca/tv-show/fbi/season-3': 'V1',
	'/ca/tv-show/champignon-witch/season-1': 'V2',
	'/ca/tv-show/beauty-and-the-beast/season-1': 'V3',
	'/ca/tv-show/dallas-1978/season-1': 'V1',
	'/ca/tv-show/arrested-development/season-2': 'V2',
	'/ca/tv-show/ellis/season-1': 'V3',
	'/ca/tv-show/and-just-like-that/season-1': 'V1',
	'/ca/tv-show/criminal-minds/season-12': 'V2',
	'/ca/tv-show/buffy-the-vampire-slayer/season-2': 'V3',
	'/ca/tv-show/american-crime-story/season-2': 'V1',
	'/ca/tv-show/brooklyn-nine-nine/season-4': 'V2',
	'/ca/tv-show/american-horror-story/season-8': 'V3',
	'/ca/tv-show/babylon-berlin/season-4': 'V1',
	'/ca/tv-show/atlanta/season-1': 'V2',
	'/ca/tv-show/bones/season-10': 'V3',
	'/ca/tv-show/billions/season-5': 'V1',
	'/ca/tv-show/doctor-who/season-7': 'V2',
	'/ca/tv-show/everwood/season-4': 'V3',
	'/ca/tv-show/as-you-stood-by/season-1': 'V1',
	'/ca/tv-show/er/season-15': 'V2',
	'/ca/tv-show/big-little-lies/season-2': 'V3',
	'/ca/tv-show/dororo-2019/season-1': 'V1',
	'/ca/tv-show/fear-the-walking-dead/season-7': 'V2',
	'/ca/tv-show/das-boot/season-1': 'V3',
	'/ca/tv-show/darkness-those-who-kill/season-4': 'V1',
	'/ca/tv-show/a-discovery-of-witches/season-3': 'V2',
	'/ca/tv-show/american-horror-story/season-10': 'V3',
	'/ca/tv-show/90-day-fiance-the-other-way/season-7': 'V1',
	'/ca/tv-show/fawlty-towers/season-1': 'V2',
	'/ca/tv-show/elementary/season-7': 'V3',
	'/ca/tv-show/american-dad/season-20': 'V1',
	'/ca/tv-show/a-plan-to-kill/season-2': 'V2',
	'/ca/tv-show/dystopia/season-1': 'V3',
	'/ca/tv-show/farscape/season-1': 'V1',
	'/ca/tv-show/buffy-the-vampire-slayer/season-6': 'V2',
	'/ca/tv-show/cheers/season-8': 'V3',
	'/ca/tv-show/er/season-3': 'V1',
	'/ca/tv-show/food-wars-shokugeki-no-soma/season-1': 'V2',
	'/ca/tv-show/dopesick/season-1': 'V3',
	'/ca/tv-show/ash-vs-evil-dead/season-1': 'V1',
	'/ca/tv-show/30-rock/season-1': 'V2',
	'/ca/tv-show/film-theory/season-9': 'V3',
	'/ca/tv-show/daisy-jones-and-the-six/season-1': 'V1',
	'/ca/tv-show/chicago-med/season-6': 'V2',
	'/ca/tv-show/c-b-strike-2017/season-2': 'V3',
	'/ca/tv-show/drawn-together/season-1': 'V1',
	'/ca/tv-show/castle/season-8': 'V2',
	'/ca/tv-show/californication/season-1': 'V3',
	'/ca/tv-show/chuck/season-1': 'V1',
	'/ca/tv-show/family-by-choice/season-1': 'V2',
	'/ca/tv-show/blood-coast/season-2': 'V3',
	'/ca/tv-show/criminal-minds/season-13': 'V1',
	'/ca/tv-show/blackadder/season-1': 'V2',
	'/ca/tv-show/chicago-p-d/season-7': 'V3',
	'/ca/tv-show/dirk-gentlys-holistic-detective-agency/season-1': 'V1',
	'/ca/tv-show/13-reasons-why/season-1': 'V2',
	'/ca/tv-show/agatha-christies-poirot/season-2': 'V3',
	'/ca/tv-show/castle/season-4': 'V1',
	'/ca/tv-show/arrested-development/season-3': 'V2',
	'/ca/tv-show/derry-girls/season-2': 'V3',
	'/ca/tv-show/downton-abbey/season-5': 'V1',
	'/ca/tv-show/chucky/season-3': 'V2',
	'/ca/tv-show/castle/season-2': 'V3',
	'/ca/tv-show/chicago-fire/season-5': 'V1',
	'/ca/tv-show/diabolik-lovers/season-1': 'V2',
	'/ca/tv-show/archer/season-2': 'V3',
	'/ca/tv-show/bojack-horseman/season-4': 'V1',
	'/ca/tv-show/animal-control/season-2': 'V2',
	'/ca/tv-show/based-on-a-true-story/season-1': 'V3',
	'/ca/tv-show/boruto-naruto-next-generations/season-2': 'V1',
	'/ca/tv-show/bobs-burgers/season-15': 'V2',
	'/ca/tv-show/andromeda/season-1': 'V3',
	'/ca/tv-show/american-monster/season-8': 'V1',
	'/ca/tv-show/er/season-12': 'V2',
	'/ca/tv-show/below-deck-mediterranean/season-10': 'V3',
	'/ca/tv-show/chicago-p-d/season-8': 'V1',
	'/ca/tv-show/deadly-class/season-1': 'V2',
	'/ca/tv-show/futurama/season-12': 'V3',
	'/ca/tv-show/domina/season-1': 'V1',
	'/ca/tv-show/breathless-2024/season-2': 'V2',
	'/ca/tv-show/friendly-rivalry/season-1': 'V3',
	'/ca/tv-show/c-i-d/season-2': 'V1',
	'/ca/tv-show/csi-miami/season-1': 'V2',
	'/ca/tv-show/carnival-row/season-1': 'V3',
	'/ca/tv-show/bel-air/season-1': 'V1',
	'/ca/tv-show/below-deck-down-under/season-3': 'V2',
	'/ca/tv-show/elementary/season-6': 'V3',
	'/ca/tv-show/ducktales/season-1': 'V1',
	'/ca/tv-show/beastars/season-1': 'V2',
	'/ca/tv-show/citadel/season-1': 'V3',
	'/ca/tv-show/coldwater/season-1': 'V1',
	'/ca/tv-show/frasier/season-1': 'V2',
	'/ca/tv-show/columbo/season-7': 'V3',
	'/ca/tv-show/fear-the-walking-dead/season-3': 'V1',
	'/ca/tv-show/er/season-4': 'V2',
	'/ca/tv-show/friends/season-9': 'V3',
	'/ca/tv-show/baby-reindeer/season-1': 'V1',
	'/ca/tv-show/anne/season-1': 'V2',
	'/ca/tv-show/a-p-bio/season-4': 'V3',
	'/ca/tv-show/a-shop-for-killers/season-1': 'V1',
	'/ca/tv-show/alska-mig/season-1': 'V2',
	'/ca/tv-show/britannia/season-1': 'V3',
	'/ca/tv-show/arrow/season-3': 'V1',
	'/ca/tv-show/fear-the-walking-dead/season-6': 'V2',
	'/ca/tv-show/family-guy/season-15': 'V3',
	'/ca/tv-show/accused-2023/season-2': 'V1',
	'/ca/tv-show/desperate-housewives/season-8': 'V2',
	'/ca/tv-show/daldal/season-1': 'V3',
	'/ca/tv-show/doctor-who/season-6': 'V1',
	'/ca/tv-show/ancient-aliens/season-2': 'V2',
	'/ca/tv-show/city-confidential/season-9': 'V3',
	'/ca/tv-show/friday-night-lights/season-2': 'V1',
	'/ca/tv-show/echo/season-1': 'V2',
	'/ca/tv-show/columbo/season-2': 'V3',
	'/ca/tv-show/future-man/season-3': 'V1',
	'/ca/tv-show/bosch/season-6': 'V2',
	'/ca/tv-show/desperate-housewives/season-4': 'V3',
	'/ca/tv-show/furies/season-1': 'V1',
	'/ca/tv-show/chicago-fire/season-7': 'V2',
	'/ca/tv-show/dating-naked/season-1': 'V3',
	'/ca/tv-show/continuum/season-1': 'V1',
	'/ca/tv-show/american-gods/season-2': 'V2',
	'/ca/tv-show/bleach/season-16': 'V3',
	'/ca/tv-show/billy-the-kid/season-1': 'V1',
	'/ca/tv-show/dr-quinn-medicine-woman/season-1': 'V2',
	'/ca/tv-show/archer/season-1': 'V3',
	'/ca/tv-show/dreaming-whilst-black/season-2': 'V1',
	'/ca/tv-show/dalgliesh-2021/season-1': 'V2',
	'/ca/tv-show/friday-night-lights/season-5': 'V3',
	'/ca/tv-show/blackadder/season-2': 'V1',
	'/ca/tv-show/code-geass-lelouch-of-the-rebellion/season-1': 'V2',
	'/ca/tv-show/and-just-like-that/season-2': 'V3',
	'/ca/tv-show/and-then-there-were-none/season-1': 'V1',
	'/ca/tv-show/dreamworks-dragons/season-1': 'V2',
	'/ca/tv-show/arrow/season-5': 'V3',
	'/ca/tv-show/csi-vegas-2021/season-3': 'V1',
	'/ca/tv-show/criminal-minds/season-15': 'V2',
	'/ca/tv-show/criminal-minds/season-8': 'V3',
	'/ca/tv-show/choose-earth/season-1': 'V1',
	'/ca/tv-show/beyond-paradise/season-1': 'V2',
	'/ca/tv-show/60-minutes/season-58': 'V3',
	'/ca/tv-show/colin-from-accounts/season-2': 'V1',
	'/ca/tv-show/blindspot/season-3': 'V2',
	'/ca/tv-show/fubar/season-1': 'V3',
	'/ca/tv-show/everybody-hates-chris/season-1': 'V1',
	'/ca/tv-show/community/season-6': 'V2',
	'/ca/tv-show/criminal-minds/season-7': 'V3',
	'/ca/tv-show/fate-apocrypha/season-1': 'V1',
	'/ca/tv-show/dawsons-creek/season-6': 'V2',
	'/ca/tv-show/ben-10-alien-force/season-1': 'V3',
	'/ca/tv-show/fruits-basket-2019/season-1': 'V1',
	'/ca/tv-show/captain-tsubasa/season-1': 'V2',
	'/ca/tv-show/acapulco/season-4': 'V3',
	'/ca/tv-show/culinary-class-wars/season-1': 'V1',
	'/ca/tv-show/all-the-sins/season-2': 'V2',
	'/ca/tv-show/escape-at-dannemora/season-1': 'V3',
	'/ca/tv-show/chicago-fire/season-8': 'V1',
	'/ca/tv-show/black-sails/season-2': 'V2',
	'/ca/tv-show/alias/season-1': 'V3',
	'/ca/tv-show/fairy-tail/season-1': 'V1',
	'/ca/tv-show/9-1-1-lone-star/season-4': 'V2',
	'/ca/tv-show/futurama/season-6': 'V3',
	'/ca/tv-show/detroiters/season-1': 'V1',
	'/ca/tv-show/feud/season-2': 'V2',
	'/ca/tv-show/call-of-the-night/season-1': 'V3',
	'/ca/tv-show/blue-bloods/season-11': 'V1',
	'/ca/tv-show/bing/season-1': 'V2',
	'/ca/tv-show/dark-side-of-the-ring/season-6': 'V3',
	'/ca/tv-show/doc-martin/season-10': 'V1',
	'/ca/tv-show/danganronpa-the-animation/season-1': 'V2',
	'/ca/tv-show/black-clover/season-4': 'V3',
	'/ca/tv-show/barry/season-4': 'V1',
	'/ca/tv-show/family-guy/season-5': 'V2',
	'/ca/tv-show/bewitched/season-1': 'V3',
	'/ca/tv-show/fatal-seduction/season-1': 'V1',
	'/ca/tv-show/eureka/season-1': 'V2',
	'/ca/tv-show/buffy-the-vampire-slayer/season-4': 'V3',
	'/ca/tv-show/bodkin/season-1': 'V1',
	'/ca/tv-show/childhoods-end/season-1': 'V2',
	'/ca/tv-show/criminal-minds/season-14': 'V3',
	'/ca/tv-show/bleach-thousand-year-blood-war/season-3': 'V1',
	'/ca/tv-show/black-butler/season-1': 'V2',
	'/ca/tv-show/doom-patrol/season-3': 'V3',
	'/ca/tv-show/futurama/season-1': 'V1',
	'/ca/tv-show/a-woman-of-substance/season-1': 'V2',
	'/ca/tv-show/community/season-3': 'V3',
	'/ca/tv-show/abandoned-engineering/season-10': 'V1',
	'/ca/tv-show/buffy-the-vampire-slayer/season-7': 'V2',
	'/ca/tv-show/bungo-stray-dogs/season-1': 'V3',
	'/ca/tv-show/agatha-christies-poirot/season-3': 'V1',
	'/ca/tv-show/andromeda/season-5': 'V2',
	'/ca/tv-show/dragons-race-to-the-edge/season-5': 'V3',
	'/ca/tv-show/feud/season-1': 'V1',
	'/ca/tv-show/columbo/season-4': 'V2',
	'/ca/tv-show/astrid-et-raphaelle/season-3': 'V3',
	'/ca/tv-show/dawsons-creek/season-3': 'V1',
	'/ca/tv-show/evil-lives-here/season-17': 'V2',
	'/ca/tv-show/empress-ki/season-1': 'V3',
	'/ca/tv-show/fbi-international/season-1': 'V1',
	'/ca/tv-show/crime-in-progress/season-1': 'V2',
	'/ca/tv-show/doctor-who/season-10': 'V3',
	'/ca/tv-show/fugitive-hunters-mexico/season-1': 'V1',
	'/ca/tv-show/captain-tsubasa/season-2': 'V2',
	'/ca/tv-show/desperate-housewives/season-5': 'V3',
	'/ca/tv-show/csi-ny/season-1': 'V1',
	'/ca/tv-show/black-sails/season-4': 'V2',
	'/ca/tv-show/arrested-development/season-5': 'V3',
	'/ca/tv-show/call-the-midwife/season-2': 'V1',
	'/ca/tv-show/ben-10/season-4': 'V2',
	'/ca/tv-show/father-brown/season-12': 'V3',
	'/ca/tv-show/dragon-ball-gt/season-1': 'V1',
	'/ca/tv-show/fake-profile/season-1': 'V2',
	'/ca/tv-show/freaks-and-geeks/season-1': 'V3',
	'/ca/tv-show/flash-gordon-1936-1940/season-1': 'V1',
	'/ca/tv-show/battlestar-galactica-1978/season-1': 'V2',
	'/ca/tv-show/based-on-a-true-story/season-2': 'V3',
	'/ca/tv-show/adventure-time-fionna-and-cake/season-1': 'V1',
	'/ca/tv-show/er/season-5': 'V2',
	'/ca/tv-show/a-remarkable-place-to-die/season-1': 'V3',
	'/ca/tv-show/baylen-out-loud/season-1': 'V1',
	'/ca/tv-show/call-the-midwife/season-5': 'V2',
	'/ca/tv-show/genius/season-2': 'V3',
	'/ca/tv-show/buffy-the-vampire-slayer/season-5': 'V1',
	'/ca/tv-show/90-day-fiance-happily-ever-after/season-9': 'V2',
	'/ca/tv-show/call-the-midwife/season-4': 'V3',
	'/ca/tv-show/elite/season-7': 'V1',
	'/ca/tv-show/droners/season-1': 'V2',
	'/ca/tv-show/batwoman/season-1': 'V3',
	'/ca/tv-show/call-the-midwife/season-8': 'V1',
	'/ca/tv-show/damages/season-1': 'V2',
	'/ca/tv-show/friday-night-lights/season-3': 'V3',
	'/ca/tv-show/ben-10/season-2': 'V1',
	'/ca/tv-show/family-guy/season-18': 'V2',
	'/ca/tv-show/celtics-city/season-1': 'V3',
	'/ca/tv-show/24/season-9': 'V1',
	'/ca/tv-show/fbi-most-wanted/season-3': 'V2',
	'/ca/tv-show/alfred-hitchcock-presents/season-7': 'V3',
	'/ca/tv-show/er/season-13': 'V1',
	'/ca/tv-show/batman/season-1': 'V2',
	'/ca/tv-show/agents-of-mystery/season-1': 'V3',
	'/ca/tv-show/counterpart/season-2': 'V1',
	'/ca/tv-show/bleach-thousand-year-blood-war/season-1': 'V2',
	'/ca/tv-show/family-guy/season-3': 'V3',
	'/ca/tv-show/akame-ga-kill/season-1': 'V1',
	'/ca/tv-show/blue-bloods/season-7': 'V2',
	'/ca/tv-show/air-disasters/season-1': 'V3',
	'/ca/tv-show/american-horror-stories/season-1': 'V1',
	'/ca/tv-show/chicago-fire/season-6': 'V2',
	'/ca/tv-show/alone/season-10': 'V3',
	'/ca/tv-show/chilling-adventures-of-sabrina/season-1': 'V1',
	'/ca/tv-show/bachelor-mansion-takeover/season-1': 'V2',
	'/ca/tv-show/dead-to-me/season-1': 'V3',
	'/ca/tv-show/dont-trust-the-b-in-apartment-23/season-1': 'V1',
	'/ca/tv-show/beauty-in-black/season-1': 'V2',
	'/ca/tv-show/dawsons-creek/season-4': 'V3',
	'/ca/tv-show/floogals/season-1': 'V1',
	'/ca/tv-show/charmed/season-3': 'V2',
	'/ca/tv-show/barry/season-2': 'V3',
	'/ca/tv-show/das-boot/season-2': 'V1',
	'/ca/tv-show/alone/season-3': 'V2',
	'/ca/tv-show/blackadder/season-4': 'V3',
	'/ca/tv-show/english-teacher/season-1': 'V1',
	'/ca/tv-show/criminal-minds-beyond-borders/season-1': 'V2',
	'/ca/tv-show/a-haunting/season-1': 'V3',
	'/ca/tv-show/blackshore/season-1': 'V1',
	'/ca/tv-show/drop-dead-diva/season-6': 'V2',
	'/ca/tv-show/family-guy/season-2': 'V3',
	'/ca/tv-show/criminal-minds/season-9': 'V1',
	'/ca/tv-show/deadliest-catch/season-21': 'V2',
	'/ca/tv-show/curb-your-enthusiasm/season-2': 'V3',
	'/ca/tv-show/bluey/season-2': 'V1',
	'/ca/tv-show/coroner/season-4': 'V2',
	'/ca/tv-show/beauty-in-black/season-2': 'V3',
	'/ca/tv-show/fist-of-the-north-star/season-1': 'V1',
	'/ca/tv-show/dark-matter/season-1': 'V2',
	'/ca/tv-show/alone/season-8': 'V3',
	'/ca/tv-show/billy-the-kid/season-2': 'V1',
	'/ca/tv-show/dcs-legends-of-tomorrow/season-3': 'V2',
	'/ca/tv-show/atlanta/season-3': 'V3',
	'/ca/tv-show/batman-the-animated-series/season-4': 'V1',
	'/ca/tv-show/frasier/season-4': 'V2',
	'/ca/tv-show/csi-crime-scene-investigation/season-12': 'V3',
	'/ca/tv-show/cold-case/season-4': 'V1',
	'/ca/tv-show/diablo-guardian/season-1': 'V2',
	'/ca/tv-show/bobs-burgers/season-1': 'V3',
	'/ca/tv-show/bosch/season-4': 'V1',
	'/ca/tv-show/ghost-in-the-shell-stand-alone-complex/season-2': 'V2',
	'/ca/tv-show/encounter/season-1': 'V3',
	'/ca/tv-show/asterix-and-obelix-the-big-fight/season-1': 'V1',
	'/ca/tv-show/from-me-to-you/season-1': 'V2',
	'/ca/tv-show/dating-naked-uk/season-2': 'V3',
	'/ca/tv-show/criminal-record/season-1': 'V1',
	'/ca/tv-show/dr-pimple-popper-breaking-out/season-1': 'V2',
	'/ca/tv-show/beastars/season-2': 'V3',
	'/ca/tv-show/cassandra/season-1': 'V1',
	'/ca/tv-show/fatal-seduction/season-2': 'V2',
	'/ca/tv-show/altered-carbon/season-2': 'V3',
	'/ca/tv-show/food-wars-shokugeki-no-soma/season-3': 'V1',
	'/ca/tv-show/cosmos-a-spacetime-odyssey/season-2': 'V2',
	'/ca/tv-show/elite/season-3': 'V3',
	'/ca/tv-show/between-the-world-and-us/season-1': 'V1',
	'/ca/tv-show/everybody-loves-raymond/season-4': 'V2',
	'/ca/tv-show/barbarians-2020/season-1': 'V3',
	'/ca/tv-show/24/season-7': 'V1',
	'/ca/tv-show/el-juego-de-las-llaves/season-3': 'V2',
	'/ca/tv-show/24/season-8': 'V3',
	'/ca/tv-show/black-ish/season-2': 'V1',
	'/ca/tv-show/dear-child/season-1': 'V2',
	'/ca/tv-show/amazing-stories-2020/season-1': 'V3',
	'/ca/tv-show/30-rock/season-3': 'V1',
	'/ca/tv-show/death-in-paradise/season-7': 'V2',
	'/ca/tv-show/alert-missing-persons-unit/season-1': 'V3',
	'/ca/tv-show/criminal-code/season-2': 'V1',
	'/ca/tv-show/barry/season-3': 'V2',
	'/ca/tv-show/call-the-midwife/season-7': 'V3',
	'/ca/tv-show/evil-lives-here/season-1': 'V1',
	'/ca/tv-show/batman-the-animated-series/season-3': 'V2',
	'/ca/tv-show/agatha-christies-poirot/season-13': 'V3',
	'/ca/tv-show/cold-case-files/season-4': 'V1',
	'/ca/tv-show/el-barco/season-1': 'V2',
	'/ca/tv-show/24/season-4': 'V3',
	'/ca/tv-show/after-life/season-3': 'V1',
	'/ca/tv-show/american-horror-stories/season-2': 'V2',
	'/ca/tv-show/creepshow/season-1': 'V3',
	'/ca/tv-show/beyond-the-dark/season-1': 'V1',
	'/ca/tv-show/american-dad/season-1': 'V2',
	'/ca/tv-show/call-the-midwife/season-3': 'V3',
	'/ca/tv-show/family-guy/season-7': 'V1',
	'/ca/tv-show/below-deck/season-12': 'V2',
	'/ca/tv-show/ben-10-ultimate-alien/season-1': 'V3',
	'/ca/tv-show/anyway-im-falling-in-love-with-you/season-1': 'V1',
	'/ca/tv-show/fixer-to-fabulous/season-7': 'V2',
	'/ca/tv-show/bates-motel/season-5': 'V3',
	'/ca/tv-show/etoile/season-1': 'V1',
	'/ca/tv-show/custer/season-1': 'V2',
	'/ca/tv-show/fear-the-walking-dead/season-5': 'V3',
	'/ca/tv-show/ghost-whisperer/season-2': 'V1',
	'/ca/tv-show/astrid-et-raphaelle/season-4': 'V2',
	'/ca/tv-show/blue-bloods/season-8': 'V3',
	'/ca/tv-show/burn-notice/season-1': 'V1',
	'/ca/tv-show/el-encargado/season-2': 'V2',
	'/ca/tv-show/cheers/season-5': 'V3',
	'/ca/tv-show/elementary/season-4': 'V1',
	'/ca/tv-show/doctor-foster/season-2': 'V2',
	'/ca/tv-show/colin-from-accounts/season-1': 'V3',
	'/ca/tv-show/elite/season-6': 'V1',
	'/ca/tv-show/12-monkeys/season-2': 'V2',
	'/ca/tv-show/cracked/season-1': 'V3',
	'/ca/tv-show/ben-and-hollys-little-kingdom/season-2': 'V1',
	'/ca/tv-show/alex-hugo/season-2': 'V2',
	'/ca/tv-show/carnival-row/season-2': 'V3',
	'/ca/tv-show/adults/season-1': 'V1',
	'/ca/tv-show/baki-hanma/season-2': 'V2',
	'/ca/tv-show/avenue-5/season-1': 'V3',
	'/ca/tv-show/departure/season-1': 'V1',
	'/ca/tv-show/capo-rise-to-power/season-1': 'V2',
	'/ca/tv-show/frasier/season-11': 'V3',
	'/ca/tv-show/elite/season-5': 'V1',
	'/ca/tv-show/brave-and-beautiful/season-1': 'V2',
	'/ca/tv-show/family-guy/season-17': 'V3',
	'/ca/tv-show/candy/season-1': 'V1',
	'/ca/tv-show/bob-and-margaret/season-1': 'V2',
	'/ca/tv-show/desperate-housewives/season-6': 'V3',
	'/ca/tv-show/death-in-paradise/season-6': 'V1',
	'/ca/tv-show/alchemy-of-souls/season-2': 'V2',
	'/ca/tv-show/courage-the-cowardly-dog/season-1': 'V3',
	'/ca/tv-show/daddy-issues/season-1': 'V1',
	'/ca/tv-show/3rd-rock-from-the-sun/season-1': 'V2',
	'/ca/tv-show/blue-bloods/season-10': 'V3',
	'/ca/tv-show/bleach/season-3': 'V1',
	'/ca/tv-show/big-shot/season-1': 'V2',
	'/ca/tv-show/dragons-the-nine-realms/season-1': 'V3',
	'/ca/tv-show/brockmire/season-2': 'V1',
	'/ca/tv-show/er/season-11': 'V2',
	'/ca/tv-show/confidence-queen/season-1': 'V3',
	'/ca/tv-show/caliphate/season-1': 'V1',
	'/ca/tv-show/black-summer/season-1': 'V2',
	'/ca/tv-show/after-life/season-2': 'V3',
	'/ca/tv-show/charmed/season-4': 'V1',
	'/ca/tv-show/behind-the-attraction/season-1': 'V2',
	'/ca/tv-show/genius/season-3': 'V3',
	'/ca/tv-show/americas-next-top-model/season-17': 'V1',
	'/ca/tv-show/americas-next-top-model/season-22': 'V2',
	'/ca/tv-show/family-guy/season-11': 'V3',
	'/ca/tv-show/agatha-christies-poirot/season-4': 'V1',
	'/ca/tv-show/according-to-jim/season-1': 'V2',
	'/ca/tv-show/designated-survivor/season-2': 'V3',
	'/ca/tv-show/el-encargado/season-1': 'V1',
	'/ca/tv-show/12-monkeys/season-4': 'V2',
	'/ca/tv-show/anthony-bourdain-no-reservations/season-2': 'V3',
	'/ca/tv-show/eastbound-and-down/season-1': 'V1',
	'/ca/tv-show/charitraheen/season-1': 'V2',
	'/ca/tv-show/amsterdam-empire/season-1': 'V3',
	'/ca/tv-show/flight-of-the-conchords/season-1': 'V1',
	'/ca/tv-show/fate-the-winx-saga/season-1': 'V2',
	'/ca/tv-show/bobs-burgers/season-4': 'V3',
	'/ca/tv-show/aleph/season-1': 'V1',
	'/ca/tv-show/constantine/season-1': 'V2',
	'/ca/tv-show/everybody-loves-raymond/season-3': 'V3',
	'/ca/tv-show/90210/season-1': 'V1',
	'/ca/tv-show/gentleman-jack/season-1': 'V2',
	'/ca/tv-show/dungeons-and-dragons/season-1': 'V3',
	'/ca/tv-show/defiance/season-1': 'V1',
	'/ca/tv-show/endeavour/season-3': 'V2',
	'/ca/tv-show/ancient-aliens/season-22': 'V3',
	'/ca/tv-show/dcs-legends-of-tomorrow/season-6': 'V1',
	'/ca/tv-show/couples-therapy-2019/season-4': 'V2',
	'/ca/tv-show/blue-exorcist/season-5': 'V3',
	'/ca/tv-show/30-rock/season-5': 'V1',
	'/ca/tv-show/black-ish/season-8': 'V2',
	'/ca/tv-show/aspirants/season-2': 'V3',
	'/ca/tv-show/csi-vegas/season-2': 'V1',
	'/ca/tv-show/annika/season-1': 'V2',
	'/ca/tv-show/beyond-the-bar/season-1': 'V3',
	'/ca/tv-show/awkward/season-1': 'V1',
	'/ca/tv-show/find-me-in-paris/season-2': 'V2',
	'/ca/tv-show/celebrity-jeopardy/season-4': 'V3',
	'/ca/tv-show/cheers/season-7': 'V1',
	'/ca/tv-show/aspirants/season-1': 'V2',
	'/ca/tv-show/digimon-beatbreak/season-1': 'V3',
	'/ca/tv-show/alex-rider/season-1': 'V1',
	'/ca/tv-show/doogie-kamealoha-m-d/season-1': 'V2',
	'/ca/tv-show/farscape/season-3': 'V3',
	'/ca/tv-show/condor/season-1': 'V1',
	'/ca/tv-show/dokgo-rewind/season-1': 'V2',
	'/ca/tv-show/agatha-christies-poirot/season-12': 'V3',
	'/ca/tv-show/archive-81/season-1': 'V1',
	'/ca/tv-show/episodes/season-4': 'V2',
	'/ca/tv-show/air-disasters/season-24': 'V3',
	'/ca/tv-show/24/season-6': 'V1',
	'/ca/tv-show/forged-in-fire/season-10': 'V2',
	'/ca/tv-show/arrow/season-8': 'V3',
	'/ca/tv-show/death-in-paradise/season-11': 'V1',
	'/ca/tv-show/eve/season-1': 'V2',
	'/ca/tv-show/charmed/season-8': 'V3',
	'/ca/tv-show/accused/season-1': 'V1',
	'/ca/tv-show/daddy-issues/season-2': 'V2',
	'/ca/tv-show/arctic-circle/season-4': 'V3',
	'/ca/tv-show/bitch-x-rich/season-1': 'V1',
	'/ca/tv-show/below-deck/season-1': 'V2',
	'/ca/tv-show/boys-over-flowers/season-1': 'V3',
	'/ca/tv-show/cable-girls/season-5': 'V1',
	'/ca/tv-show/blue-spring-ride/season-1': 'V2',
	'/ca/tv-show/felicity/season-1': 'V3',
	'/ca/tv-show/black-lagoon/season-1': 'V1',
	'/ca/tv-show/company-retreat/season-1': 'V2',
	'/ca/tv-show/blue-bloods/season-2': 'V3',
	'/ca/tv-show/class-of-lies/season-1': 'V1',
	'/ca/tv-show/americas-next-top-model/season-20': 'V2',
	'/ca/tv-show/fate-zero/season-2': 'V3',
	'/ca/tv-show/get-smart-1965/season-1': 'V1',
	'/ca/tv-show/dragon-ball/season-5': 'V2',
	'/ca/tv-show/csi-crime-scene-investigation/season-10': 'V3',
	'/ca/tv-show/csi-crime-scene-investigation/season-5': 'V1',
	'/ca/tv-show/dr-death/season-2': 'V2',
	'/ca/tv-show/europe-from-above/season-5': 'V3',
	'/ca/tv-show/batwoman/season-3': 'V1',
	'/ca/tv-show/contraband-seized-at-the-border/season-8': 'V2',
	'/ca/tv-show/csi-crime-scene-investigation/season-7': 'V3',
	'/ca/tv-show/dragons-race-to-the-edge/season-1': 'V1',
	'/ca/tv-show/fantastic-friends/season-1': 'V2',
	'/ca/tv-show/borgen/season-3': 'V3',
	'/ca/tv-show/edens-zero/season-2': 'V1',
	'/ca/tv-show/alone/season-9': 'V2',
	'/ca/tv-show/food-wars-shokugeki-no-soma/season-2': 'V3',
	'/ca/tv-show/angela-anaconda/season-3': 'V1',
	'/ca/tv-show/cold-case/season-2': 'V2',
	'/ca/tv-show/as-the-crow-flies/season-3': 'V3',
	'/ca/tv-show/21-jump-street/season-1': 'V1',
	'/ca/tv-show/drawn-together/season-2': 'V2',
	'/ca/tv-show/dcs-legends-of-tomorrow/season-2': 'V3',
	'/ca/tv-show/buried-in-the-backyard/season-6': 'V1',
	'/ca/tv-show/al-hayba/season-2': 'V2',
	'/ca/tv-show/elfen-lied/season-1': 'V3',
	'/ca/tv-show/classroom-of-the-elite/season-1': 'V1',
	'/ca/tv-show/futurama/season-5': 'V2',
	'/ca/tv-show/ex-on-the-beach/season-9': 'V3',
	'/ca/tv-show/bewitched/season-2': 'V1',
	'/ca/tv-show/a-mothers-son/season-1': 'V2',
	'/ca/tv-show/alone/season-7': 'V3',
	'/ca/tv-show/bupkis/season-1': 'V1',
	'/ca/tv-show/daria/season-5': 'V2',
	'/ca/tv-show/death-and-other-details/season-1': 'V3',
	'/ca/tv-show/angel/season-2': 'V1',
	'/ca/tv-show/delhi-crime/season-3': 'V2',
	'/ca/tv-show/affinity/season-1': 'V3',
	'/ca/tv-show/elite/season-4': 'V1',
	'/ca/tv-show/death-in-paradise/season-8': 'V2',
	'/ca/tv-show/boardwalk-empire/season-4': 'V3',
	'/ca/tv-show/californication/season-6': 'V1',
	'/ca/tv-show/expedition-unknown/season-1': 'V2',
	'/ca/tv-show/bleach-thousand-year-blood-war/season-2': 'V3',
	'/ca/tv-show/catch-22/season-1': 'V1',
	'/ca/tv-show/frasier/season-3': 'V2',
	'/ca/tv-show/dr-romantic/season-1': 'V3',
	'/ca/tv-show/endless-love-2015/season-1': 'V1',
	'/ca/tv-show/diario-de-un-gigolo/season-1': 'V2',
	'/ca/tv-show/boris/season-1': 'V3',
	'/ca/tv-show/das-boot/season-3': 'V1',
	'/ca/tv-show/csi-miami/season-5': 'V2',
	'/ca/tv-show/csi-crime-scene-investigation/season-9': 'V3',
	'/ca/tv-show/britannia/season-3': 'V1',
	'/ca/tv-show/family-guy/season-6': 'V2',
	'/ca/tv-show/ben-10-omniverse/season-1': 'V3',
	'/ca/tv-show/deutschland-83/season-1': 'V1',
	'/ca/tv-show/danny-will-die-alone/season-3': 'V2',
	'/ca/tv-show/fighting-spirit/season-3': 'V3',
	'/ca/tv-show/fruits-basket-2019/season-2': 'V1',
	'/ca/tv-show/fbi-international/season-3': 'V2',
	'/ca/tv-show/exploding-kittens/season-1': 'V3',
	'/ca/tv-show/clevatess/season-1': 'V1',
	'/ca/tv-show/father-brown/season-3': 'V2',
	'/ca/tv-show/americas-next-top-model/season-8': 'V3',
	'/ca/tv-show/backstreet-rookie/season-1': 'V1',
	'/ca/tv-show/ancient-aliens/season-21': 'V2',
	'/ca/tv-show/conan-obrien-must-go/season-2': 'V3',
	'/ca/tv-show/curb-your-enthusiasm/season-10': 'V1',
	'/ca/tv-show/evil-lives-here/season-13': 'V2',
	'/ca/tv-show/borgia/season-1': 'V3',
	'/ca/tv-show/everybody-loves-raymond/season-8': 'V1',
	'/ca/tv-show/call-the-midwife/season-12': 'V2',
	'/ca/tv-show/dragon-raja/season-1': 'V3',
	'/ca/tv-show/cats-eye/season-1': 'V1',
	'/ca/tv-show/dublin-murders/season-1': 'V2',
	'/ca/tv-show/connect-2022/season-1': 'V3',
	'/ca/tv-show/doctor-who-2013/season-12': 'V1',
	'/ca/tv-show/ever-after-high/season-1': 'V2',
	'/ca/tv-show/a-gentleman-in-moscow/season-1': 'V3',
	'/ca/tv-show/family-matters-2024/season-1': 'V1',
	'/ca/tv-show/arthdal-chronicles/season-2': 'V2',
	'/ca/tv-show/beyblade/season-1': 'V3',
	'/ca/tv-show/chip-n-dale-rescue-rangers/season-2': 'V1',
	'/ca/tv-show/big-hero-6-the-series/season-2': 'V2',
	'/ca/tv-show/dead-to-me/season-3': 'V3',
	'/ca/tv-show/everybody-loves-raymond/season-1': 'V1',
	'/ca/tv-show/endless-love-2015/season-2': 'V2',
	'/ca/tv-show/everybody-hates-chris/season-4': 'V3',
	'/ca/tv-show/endeavour/season-8': 'V1',
	'/ca/tv-show/bull/season-2': 'V2',
	'/ca/tv-show/dont-toy-with-me-miss-nagatoro/season-1': 'V3',
	'/ca/tv-show/chez-maupassant/season-1': 'V1',
	'/ca/tv-show/erica/season-1': 'V2',
	'/ca/tv-show/chuck/season-4': 'V3',
	'/ca/tv-show/americas-next-top-model/season-9': 'V1',
	'/ca/tv-show/domestic-girlfriend/season-1': 'V2',
	'/ca/tv-show/agatha-christies-marple/season-2': 'V3',
	'/ca/tv-show/csi-crime-scene-investigation/season-2': 'V1',
	'/ca/tv-show/babylon-5/season-4': 'V2',
	'/ca/tv-show/dragon-ball-z-1989/season-9': 'V3',
	'/ca/tv-show/ash-vs-evil-dead/season-2': 'V1',
	'/ca/tv-show/an-incurable-case-of-love/season-1': 'V2',
	'/ca/tv-show/flashpoint/season-3': 'V3',
	'/ca/tv-show/four-more-shots-please/season-4': 'V1',
	'/ca/tv-show/futurama/season-9': 'V2',
	'/ca/tv-show/american-dad/season-13': 'V3',
	'/ca/tv-show/chasing-the-west/season-1': 'V1',
	'/ca/tv-show/family-guy/season-13': 'V2',
	'/ca/tv-show/americas-next-top-model/season-21': 'V3',
	'/ca/tv-show/below-deck-down-under/season-1': 'V1',
	'/ca/tv-show/cheers/season-3': 'V2',
	'/ca/tv-show/bob-abishola/season-1': 'V3',
	'/ca/tv-show/better-off-ted/season-1': 'V1',
	'/ca/tv-show/americas-next-top-model/season-15': 'V2',
	'/ca/tv-show/britannia/season-2': 'V3',
	'/ca/tv-show/bonanza/season-1': 'V1',
	'/ca/tv-show/chucky/season-2': 'V2',
	'/ca/tv-show/gantz/season-1': 'V3',
	'/ca/tv-show/csi-miami/season-2': 'V1',
	'/ca/tv-show/family-law-2021/season-1': 'V2',
	'/ca/tv-show/all-the-light-we-cannot-see/season-1': 'V3',
	'/ca/tv-show/arifureta-from-commonplace-to-worlds-strongest/season-1': 'V1',
	'/ca/tv-show/carnivale/season-1': 'V2',
	'/ca/tv-show/follow-me/season-1': 'V3',
	'/ca/tv-show/disasters-at-sea/season-2': 'V1',
	'/ca/tv-show/chuck/season-5': 'V2',
	'/ca/tv-show/almost-paradise/season-2': 'V3',
	'/ca/tv-show/con-man/season-1': 'V1',
	'/ca/tv-show/air-disasters/season-9': 'V2',
	'/ca/tv-show/bull/season-6': 'V3',
	'/ca/tv-show/cold-case/season-7': 'V1',
	'/ca/tv-show/bad-and-crazy/season-1': 'V2',
	'/ca/tv-show/csi-crime-scene-investigation/season-11': 'V3',
	'/ca/tv-show/curb-your-enthusiasm/season-8': 'V1',
	'/ca/tv-show/from-scratch/season-1': 'V2',
	'/ca/tv-show/fairy-tail/season-8': 'V3',
	'/ca/tv-show/dr-quinn-medicine-woman/season-3': 'V1',
	'/ca/tv-show/boy-meets-world/season-7': 'V2',
	'/ca/tv-show/brassic/season-5': 'V3',
	'/ca/tv-show/berserk-the-golden-age-arc-memorial-edition/season-1': 'V1',
	'/ca/tv-show/aussie-gold-hunters/season-10': 'V2',
	'/ca/tv-show/csi-crime-scene-investigation/season-3': 'V3',
	'/ca/tv-show/barbarians-2020/season-2': 'V1',
	'/ca/tv-show/curb-your-enthusiasm/season-9': 'V2',
	'/ca/tv-show/careme/season-1': 'V3',
	'/ca/tv-show/alert-missing-persons-unit/season-2': 'V1',
	'/ca/tv-show/community/season-4': 'V2',
	'/ca/tv-show/doctor-who-2013/season-26': 'V3',
	'/ca/tv-show/amazing-stories/season-1': 'V1',
	'/ca/tv-show/dragon-ball-z-1989/season-7': 'V2',
	'/ca/tv-show/americas-next-top-model/season-18': 'V3',
	'/ca/tv-show/dynasty-2017/season-1': 'V1',
	'/ca/tv-show/cruel-summer/season-1': 'V2',
	'/ca/tv-show/9-1-1-lone-star/season-2': 'V3',
	'/ca/tv-show/black-ish/season-1': 'V1',
	'/ca/tv-show/durarara/season-2': 'V2',
	'/ca/tv-show/carnivale/season-2': 'V3',
	'/ca/tv-show/dusk-beyond-the-end-of-the-world/season-1': 'V1',
	'/ca/tv-show/9-1-1-lone-star/season-3': 'V2',
	'/ca/tv-show/another-self/season-1': 'V3',
	'/ca/tv-show/couples-therapy-2019/season-3': 'V1',
	'/ca/tv-show/13-reasons-why/season-4': 'V2',
	'/ca/tv-show/beowulf-return-to-the-shieldlands/season-1': 'V3',
	'/ca/tv-show/benza-english/season-1': 'V1',
	'/ca/tv-show/belgravia/season-1': 'V2',
	'/ca/tv-show/13-reasons-why/season-3': 'V3',
	'/ca/tv-show/channel-zero/season-2': 'V1',
	'/ca/tv-show/cardinal/season-2': 'V2',
	'/ca/tv-show/blue-skies/season-1': 'V3',
	'/ca/tv-show/find-me-in-your-memory/season-1': 'V1',
	'/ca/tv-show/7th-time-loop-the-villainess-enjoys-a-carefree-life-married-to-her-worst-enemy-2024/season-1': 'V2',
	'/ca/tv-show/allegiance-2024/season-1': 'V3',
	'/ca/tv-show/bobs-burgers/season-5': 'V1',
	'/ca/tv-show/futurama/season-8': 'V2',
	'/ca/tv-show/beauty-and-the-billionaire/season-1': 'V3',
	'/ca/tv-show/couples-therapy-2019/season-2': 'V1',
	'/ca/tv-show/cheers/season-10': 'V2',
	'/ca/tv-show/bobs-burgers/season-11': 'V3',
	'/ca/tv-show/baywatch/season-2': 'V1',
	'/ca/tv-show/final-space/season-1': 'V2',
	'/ca/tv-show/1000-lb-sisters/season-4': 'V3',
	'/ca/tv-show/angels-of-death/season-1': 'V1',
	'/ca/tv-show/continuum/season-2': 'V2',
	'/ca/tv-show/doraemon/season-1': 'V3',
	'/ca/tv-show/darkwing-duck/season-1': 'V1',
	'/ca/tv-show/dr-death/season-1': 'V2',
	'/ca/tv-show/citrus/season-1': 'V3',
	'/ca/tv-show/bloodline/season-1': 'V1',
	'/ca/tv-show/big-time-rush/season-1': 'V2',
	'/ca/tv-show/21-jump-street/season-4': 'V3',
	'/ca/tv-show/early-edition/season-1': 'V1',
	'/ca/tv-show/father-ted/season-1': 'V2',
	'/ca/tv-show/dakaichi-im-being-harassed-by-the-sexiest-man-of-the-year/season-1': 'V3',
	'/ca/tv-show/big-mouth/season-1': 'V1',
	'/ca/tv-show/antiques-road-trip/season-1': 'V2',
	'/ca/tv-show/dragon-ball-z-kai/season-2': 'V3',
	'/ca/tv-show/americas-next-top-model/season-14': 'V1',
	'/ca/tv-show/devilman-crybaby/season-1': 'V2',
	'/ca/tv-show/dance-academy/season-3': 'V3',
	'/ca/tv-show/episodes/season-5': 'V1',
	'/ca/tv-show/90210/season-2': 'V2',
	'/ca/tv-show/drake-and-josh/season-3': 'V3',
	'/ca/tv-show/find-me-in-paris/season-1': 'V1',
	'/ca/tv-show/bobs-burgers/season-14': 'V2',
	'/ca/tv-show/atypical/season-1': 'V3',
	'/ca/tv-show/episodes/season-2': 'V1',
	'/ca/tv-show/covert-affairs/season-5': 'V2',
	'/ca/tv-show/after-the-rain/season-1': 'V3',
	'/ca/tv-show/americas-funniest-home-videos/season-36': 'V1',
	'/ca/tv-show/charmed/season-5': 'V2',
	'/ca/tv-show/bleach/season-15': 'V3',
	'/ca/tv-show/betty/season-1': 'V1',
	'/ca/tv-show/cells-at-work/season-1': 'V2',
	'/ca/tv-show/classroom-of-the-elite/season-3': 'V3',
	'/ca/tv-show/find-me-in-paris/season-3': 'V1',
	'/ca/tv-show/craig-of-the-creek/season-1': 'V2',
	'/ca/tv-show/dinosaurs/season-1': 'V3',
	'/ca/tv-show/des-2020/season-1': 'V1',
	'/ca/tv-show/fairy-tail/season-7': 'V2',
	'/ca/tv-show/departure/season-2': 'V3',
	'/ca/tv-show/alf/season-4': 'V1',
	'/ca/tv-show/doc-martin/season-9': 'V2',
	'/ca/tv-show/doc-martin/season-8': 'V3',
	'/ca/tv-show/dragon-ball-z-1989/season-8': 'V1',
	'/ca/tv-show/c-the-money-of-soul-and-possibility-control/season-1': 'V2',
	'/ca/tv-show/blindspot/season-4': 'V3',
	'/ca/tv-show/doctor-who-2013/season-14': 'V1',
	'/ca/tv-show/agatha-christies-poirot/season-9': 'V2',
	'/ca/tv-show/a-d-police-files/season-1': 'V3',
	'/ca/tv-show/flashpoint/season-4': 'V1',
	'/ca/tv-show/blindspot/season-5': 'V2',
	'/ca/tv-show/anthony-bourdain-no-reservations/season-1': 'V3',
	'/ca/tv-show/batman/season-2': 'V1',
	'/ca/tv-show/americas-next-top-model/season-12': 'V2',
	'/ca/tv-show/dragon-ball-z-kai/season-7': 'V3',
	'/ca/tv-show/el-internado/season-1': 'V1',
	'/ca/tv-show/fairy-tail/season-6': 'V2',
	'/ca/tv-show/alone/season-4': 'V3',
	'/ca/tv-show/from-old-country-bumpkin-to-master-swordsman/season-1': 'V1',
	'/ca/tv-show/30-for-30/season-3': 'V2',
	'/ca/tv-show/agatha-christies-poirot/season-6': 'V3',
	'/ca/tv-show/boardwalk-empire/season-5': 'V1',
	'/ca/tv-show/americas-next-top-model/season-11': 'V2',
	'/ca/tv-show/channel-zero/season-4': 'V3',
	'/ca/tv-show/digimon-digital-monsters/season-2': 'V1',
	'/ca/tv-show/evil-lives-here/season-2': 'V2',
	'/ca/tv-show/endeavour/season-2': 'V3',
	'/ca/tv-show/better-things/season-1': 'V1',
	'/ca/tv-show/amanda-and-alans-italian-job/season-2': 'V2',
	'/ca/tv-show/a-place-to-call-home/season-1': 'V3',
	'/ca/tv-show/cheers/season-6': 'V1',
	'/ca/tv-show/battlestar-galactica-1978/season-2': 'V2',
	'/ca/tv-show/endeavour/season-4': 'V3',
	'/ca/tv-show/di4ri/season-1': 'V1',
	'/ca/tv-show/farscape/season-2': 'V2',
	'/ca/tv-show/dynasty/season-1': 'V3',
	'/ca/tv-show/archer/season-9': 'V1',
	'/ca/tv-show/family-guy/season-16': 'V2',
	'/ca/tv-show/30-for-30/season-2': 'V3',
	'/ca/tv-show/beverly-hills-90210/season-8': 'V1',
	'/ca/tv-show/dcs-legends-of-tomorrow/season-5': 'V2',
	'/ca/tv-show/alice-nevers-le-juge-est-une-femme/season-1': 'V3',
	'/ca/tv-show/falling-into-your-smile/season-1': 'V1',
	'/ca/tv-show/danny-phantom/season-1': 'V2',
	'/ca/tv-show/californication/season-5': 'V3',
	'/ca/tv-show/dinosaurs/season-2': 'V1',
	'/ca/tv-show/boss/season-1': 'V2',
	'/ca/tv-show/agatha-christies-poirot/season-7': 'V3',
	'/ca/tv-show/are-you-safe/season-1': 'V1',
	'/ca/tv-show/call-the-midwife/season-9': 'V2',
	'/ca/tv-show/a-girl-and-her-guard-dog/season-1': 'V3',
	'/ca/tv-show/beauty-and-the-beast/season-2': 'V1',
	'/ca/tv-show/fourever-you/season-1': 'V2',
	'/ca/tv-show/el-encargado/season-3': 'V3',
	'/ca/tv-show/alone/season-5': 'V1',
	'/ca/tv-show/bat-fam/season-1': 'V2',
	'/ca/tv-show/atypical/season-3': 'V3',
	'/ca/tv-show/conan-obrien-must-go/season-1': 'V1',
	'/ca/tv-show/absolutely-fabulous/season-1': 'V2',
	'/ca/tv-show/aka-charlie-sheen/season-1': 'V3',
	'/ca/tv-show/alf/season-2': 'V1',
	'/ca/tv-show/bandidos/season-2': 'V2',
	'/ca/tv-show/emerald-city/season-1': 'V3',
	'/ca/tv-show/banana-fish/season-1': 'V1',
	'/ca/tv-show/black-ish/season-3': 'V2',
	'/ca/tv-show/breakout-kings/season-1': 'V3',
	'/ca/tv-show/dirilis-ertugrul/season-1': 'V1',
	'/ca/tv-show/digman/season-1': 'V2',
	'/ca/tv-show/forensic-files/season-3': 'V3',
	'/ca/tv-show/all-american/season-1': 'V1',
	'/ca/tv-show/big-city-greens/season-1': 'V2',
	'/ca/tv-show/all-in-the-family/season-1': 'V3',
	'/ca/tv-show/food-wars-shokugeki-no-soma/season-4': 'V1',
	'/ca/tv-show/crossing-lines/season-3': 'V2',
	'/ca/tv-show/discovering-film/season-1': 'V3',
	'/ca/tv-show/food-wars-shokugeki-no-soma/season-5': 'V1',
	'/ca/tv-show/dallas-1978/season-6': 'V2',
	'/ca/tv-show/dickinson/season-3': 'V3',
	'/ca/tv-show/fleishman-is-in-trouble/season-1': 'V1',
	'/ca/tv-show/dragon-ball-z-kai/season-3': 'V2',
	'/ca/tv-show/candice-renoir/season-9': 'V3',
	'/ca/tv-show/a-woman-of-substance/season-2': 'V1',
	'/ca/tv-show/batman-the-brave-and-the-bold/season-3': 'V2',
	'/ca/tv-show/fireman-sam/season-6': 'V3',
	'/ca/tv-show/forged-in-fire/season-1': 'V1',
	'/ca/tv-show/48-hours/season-38': 'V2',
	'/ca/tv-show/diabolik-lovers/season-2': 'V3',
	'/ca/tv-show/exit-2019/season-1': 'V1',
	'/ca/tv-show/ghost-doctor/season-1': 'V2',
	'/ca/tv-show/continuum/season-3': 'V3',
	'/ca/tv-show/city-on-a-hill/season-1': 'V1',
	'/ca/tv-show/black-dynamite/season-1': 'V2',
	'/ca/tv-show/forged-in-fire/season-11': 'V3',
	'/ca/tv-show/final-space/season-3': 'V1',
	'/ca/tv-show/dance-moms/season-6': 'V2',
	'/ca/tv-show/baywatch/season-8': 'V3',
	'/ca/tv-show/furia/season-1': 'V1',
	'/ca/tv-show/divorce-lawyer/season-2': 'V2',
	'/ca/tv-show/diners-drive-ins-and-dives/season-53': 'V3',
	'/ca/tv-show/a-cooks-tour/season-1': 'V1',
	'/ca/tv-show/fresh-off-the-boat/season-6': 'V2',
	'/ca/tv-show/frankenstein/season-1': 'V3',
	'/ca/tv-show/candice-renoir/season-1': 'V1',
	'/ca/tv-show/black-ish/season-5': 'V2',
	'/ca/tv-show/black-lightning/season-1': 'V3',
	'/ca/tv-show/anthony-bourdain-parts-unknown/season-4': 'V1',
	'/ca/tv-show/fake-profile/season-2': 'V2',
	'/ca/tv-show/bull/season-5': 'V3',
	'/ca/tv-show/4-blocks/season-1': 'V1',
	'/ca/tv-show/endeavour/season-5': 'V2',
	'/ca/tv-show/anne/season-3': 'V3',
	'/ca/tv-show/air-disasters/season-7': 'V1',
	'/ca/tv-show/emma/season-1': 'V2',
	'/ca/tv-show/cheer-up-2022/season-1': 'V3',
	'/ca/tv-show/bakugan-battle-brawlers/season-1': 'V1',
	'/ca/tv-show/ben-10-ultimate-alien/season-2': 'V2',
	'/ca/tv-show/atomic/season-1': 'V3',
	'/ca/tv-show/dragon-ball-z-1989/season-6': 'V1',
	'/ca/tv-show/alfred-hitchcock-presents/season-6': 'V2',
	'/ca/tv-show/baskets/season-1': 'V3',
	'/ca/tv-show/angel/season-4': 'V1',
	'/ca/tv-show/celebrity-iou/season-11': 'V2',
	'/ca/tv-show/american-dad/season-17': 'V3',
	'/ca/tv-show/baby-einstein-classics/season-1': 'V1',
	'/ca/tv-show/dancing-with-the-stars/season-34': 'V2',
	'/ca/tv-show/city-on-a-hill/season-3': 'V3',
	'/ca/tv-show/genera-ion/season-1': 'V1',
	'/ca/tv-show/cheers/season-11': 'V2',
	'/ca/tv-show/baby-bandito/season-2': 'V3',
	'/ca/tv-show/el-internado/season-6': 'V1',
	'/ca/tv-show/americas-next-top-model/season-16': 'V2',
	'/ca/tv-show/cardinal/season-3': 'V3',
	'/ca/tv-show/f1-the-academy/season-1': 'V1',
	'/ca/tv-show/bloom-into-you/season-1': 'V2',
	'/ca/tv-show/chuck/season-2': 'V3',
	'/ca/tv-show/a-place-to-call-home/season-6': 'V1',
	'/ca/tv-show/arifureta-from-commonplace-to-worlds-strongest/season-2': 'V2',
	'/ca/tv-show/chillin-in-another-world-with-level-2-super-cheat-powers/season-1': 'V3',
	'/ca/tv-show/charmed-2018/season-1': 'V1',
	'/ca/tv-show/bored-to-death/season-1': 'V2',
	'/ca/tv-show/bewitched/season-4': 'V3',
	'/ca/tv-show/escape-to-the-country/season-24': 'V1',
	'/ca/tv-show/casse-gueule-2026/season-1': 'V2',
	'/ca/tv-show/angel/season-5': 'V3',
	'/ca/tv-show/dragons-race-to-the-edge/season-6': 'V1',
	'/ca/tv-show/bull/season-4': 'V2',
	'/ca/tv-show/forensic-files/season-1': 'V3',
	'/ca/tv-show/dora-the-explorer/season-1': 'V1',
	'/ca/tv-show/almas-not-normal/season-2': 'V2',
	'/ca/tv-show/flex-x-cop/season-1': 'V3',
	'/ca/tv-show/ghost-adventures/season-1': 'V1',
	'/ca/tv-show/dc-super-hero-girls/season-2': 'V2',
	'/ca/tv-show/alfred-hitchcock-presents/season-4': 'V3',
	'/ca/tv-show/channel-zero/season-3': 'V1',
	'/ca/tv-show/calls-2021/season-1': 'V2',
	'/ca/tv-show/forensic-files/season-11': 'V3',
	'/ca/tv-show/charitraheen/season-3': 'V1',
	'/ca/tv-show/csi-ny/season-7': 'V2',
	'/ca/tv-show/dallas-1978/season-7': 'V3',
	'/ca/tv-show/alias/season-5': 'V1',
	'/ca/tv-show/el-marginal/season-4': 'V2',
	'/ca/tv-show/doctor-who-2013/season-3': 'V3',
	'/ca/tv-show/dateline/season-33': 'V1',
	'/ca/tv-show/chemistry-of-death/season-1': 'V2',
	'/ca/tv-show/easy/season-1': 'V3',
	'/ca/tv-show/alone-australia/season-2': 'V1',
	'/ca/tv-show/candice-renoir/season-8': 'V2',
	'/ca/tv-show/almost-paradise/season-1': 'V3',
	'/ca/tv-show/catastrophe-2015/season-1': 'V1',
	'/ca/tv-show/atypical/season-2': 'V2',
	'/ca/tv-show/3-roses/season-1': 'V3',
	'/ca/tv-show/alvinnn-and-the-chipmunks/season-5': 'V1',
	'/ca/tv-show/air-disasters/season-12': 'V2',
	'/ca/tv-show/gavin-and-stacey/season-4': 'V3',
	'/ca/tv-show/crossing-lines/season-2': 'V1',
	'/ca/tv-show/all-the-queens-men/season-1': 'V2',
	'/ca/tv-show/berserk-of-gluttony/season-1': 'V3',
	'/ca/tv-show/dark-side-of-the-ring/season-5': 'V1',
	'/ca/tv-show/blakes-7/season-1': 'V2',
	'/ca/tv-show/ancient-aliens/season-16': 'V3',
	'/ca/tv-show/galactik-football/season-1': 'V1',
	'/ca/tv-show/exchange/season-1': 'V2',
	'/ca/tv-show/a-french-village/season-1': 'V3',
	'/ca/tv-show/blue-exorcist/season-3': 'V1',
	'/ca/tv-show/alone-australia/season-3': 'V2',
	'/ca/tv-show/art-of-crime/season-7': 'V3',
	'/ca/tv-show/archer/season-6': 'V1',
	'/ca/tv-show/a-kind-of-spark/season-1': 'V2',
	'/ca/tv-show/degrassi-the-next-generation/season-12': 'V3',
	'/ca/tv-show/downhill-skiers-aint-no-mountain-steep-enough/season-1': 'V1',
	'/ca/tv-show/gaus-electronics/season-1': 'V2',
	'/ca/tv-show/from-me-to-you/season-3': 'V3',
	'/ca/tv-show/cucumber/season-1': 'V1',
	'/ca/tv-show/endeavour/season-6': 'V2',
	'/ca/tv-show/cranford/season-1': 'V3',
	'/ca/tv-show/danger-force/season-3': 'V1',
	'/ca/tv-show/according-to-jim/season-4': 'V2',
	'/ca/tv-show/batwoman/season-2': 'V3',
	'/ca/tv-show/a-very-english-scandal/season-3': 'V1',
	'/ca/tv-show/90-day-fiance-the-other-way/season-1': 'V2',
	'/ca/tv-show/friday-night-dinner/season-1': 'V3',
	'/ca/tv-show/code-black/season-1': 'V1',
	'/ca/tv-show/a-french-village/season-2': 'V2',
	'/ca/tv-show/creepshow/season-2': 'V3',
	'/ca/tv-show/civilisations/season-1': 'V1',
	'/ca/tv-show/boris/season-4': 'V2',
	'/ca/tv-show/conversations-with-a-killer-the-ted-bundy-tapes/season-1': 'V3',
	'/ca/tv-show/death-comes-to-pemberley/season-1': 'V1',
	'/ca/tv-show/gangnam-b-side/season-1': 'V2',
	'/ca/tv-show/doctor-who-2013/season-2': 'V3',
	'/ca/tv-show/beauty-and-the-beast/season-3': 'V1',
	'/ca/tv-show/beyblade-burst/season-2': 'V2',
	'/ca/tv-show/8-simple-rules-for-dating-my-teenage-daughter/season-2': 'V3',
	'/ca/tv-show/all-american/season-2': 'V1',
	'/ca/tv-show/dallas-1978/season-14': 'V2',
	'/ca/tv-show/black-sands/season-1': 'V3',
	'/ca/tv-show/burn-notice/season-5': 'V1',
	'/ca/tv-show/an-idiot-abroad/season-1': 'V2',
	'/ca/tv-show/csi-crime-scene-investigation/season-13': 'V3',
	'/ca/tv-show/carol-and-the-end-of-the-world/season-1': 'V1',
	'/ca/tv-show/2-days-and-1-night/season-4': 'V2',
	'/ca/tv-show/endeavour/season-7': 'V3',
	'/ca/tv-show/ben-10-omniverse/season-8': 'V1',
	'/ca/tv-show/csi-crime-scene-investigation/season-8': 'V2',
	'/ca/tv-show/beyblade-metal-fusion/season-2': 'V3',
	'/ca/tv-show/adam-ruins-everything/season-2': 'V1',
	'/ca/tv-show/alvinnn-and-the-chipmunks/season-2': 'V2',
	'/ca/tv-show/date-a-live/season-1': 'V3',
	'/ca/tv-show/cursed/season-1': 'V1',
	'/ca/tv-show/blaze-and-the-monster-machines/season-2': 'V2',
	'/ca/tv-show/charmed/season-7': 'V3',
	'/ca/tv-show/beyblade-burst/season-3': 'V1',
	'/ca/tv-show/deep-state/season-1': 'V2',
	'/ca/tv-show/3/season-4': 'V3',
	'/ca/tv-show/doctor-who-2013/season-4': 'V1',
	'/ca/tv-show/alias/season-4': 'V2',
	'/ca/tv-show/fireman-sam/season-7': 'V3',
	'/ca/tv-show/alien-encounters-fact-or-fiction/season-1': 'V1',
	'/ca/tv-show/dragon-ball-z-kai/season-6': 'V2',
	'/ca/tv-show/agatha-raisin/season-1': 'V3',
	'/ca/tv-show/ancient-aliens/season-11': 'V1',
	'/ca/tv-show/expedition-x/season-10': 'V2',
	'/ca/tv-show/agatha-christies-poirot/season-8': 'V3',
	'/ca/tv-show/anna-2022/season-1': 'V1',
	'/ca/tv-show/betty-la-fea-the-story-continues/season-2': 'V2',
	'/ca/tv-show/beyond/season-1': 'V3',
	'/ca/tv-show/fuller-house/season-1': 'V1',
	'/ca/tv-show/beyond-the-boundary/season-1': 'V2',
	'/ca/tv-show/dear-hongrang/season-1': 'V3',
	'/ca/tv-show/90-day-fiance-the-other-way/season-6': 'V1',
	'/ca/tv-show/evil-lives-here/season-5': 'V2',
	'/ca/tv-show/divorce/season-1': 'V3',
	'/ca/tv-show/800-words/season-3': 'V1',
	'/ca/tv-show/body-of-proof/season-2': 'V2',
	'/ca/tv-show/csi-ny/season-9': 'V3',
	'/ca/tv-show/code-black/season-2': 'V1',
	'/ca/tv-show/desert-law/season-1': 'V2',
	'/ca/tv-show/batwheels/season-3': 'V3',
	'/ca/tv-show/dragon-ball-z-kai/season-5': 'V1',
	'/ca/tv-show/below-deck-mediterranean/season-1': 'V2',
	'/ca/tv-show/berlin-station/season-2': 'V3',
	'/ca/tv-show/fated-to-love-you-2014/season-1': 'V1',
	'/ca/tv-show/amphibia/season-1': 'V2',
	'/ca/tv-show/dead-pixels/season-1': 'V3',
	'/ca/tv-show/geek-girl/season-1': 'V1',
	'/ca/tv-show/csi-crime-scene-investigation/season-14': 'V2',
	'/ca/tv-show/american-dad/season-18': 'V3',
	'/ca/tv-show/duck-dynasty-the-revival/season-1': 'V1',
	'/ca/tv-show/bofuri-i-dont-want-to-get-hurt-so-ill-max-out-my-defense/season-1': 'V2',
	'/ca/tv-show/criminal-minds-beyond-borders/season-2': 'V3',
	'/ca/tv-show/futurama/season-10': 'V1',
	'/ca/tv-show/batman-beyond/season-3': 'V2',
	'/ca/tv-show/courage-the-cowardly-dog/season-2': 'V3',
	'/ca/tv-show/beverly-hills-90210/season-5': 'V1',
	'/ca/tv-show/flashpoint/season-2': 'V2',
	'/ca/tv-show/anthony-bourdain-no-reservations/season-6': 'V3',
	'/ca/tv-show/fireman-sam/season-9': 'V1',
	'/ca/tv-show/code-breaker/season-1': 'V2',
	'/ca/tv-show/class-of-07/season-1': 'V3',
	'/ca/tv-show/deadmans-curse/season-3': 'V1',
	'/ca/tv-show/explained/season-3': 'V2',
	'/ca/tv-show/digimon-adventure-2020/season-1': 'V3',
	'/ca/tv-show/adam-ruins-everything/season-1': 'V1',
	'/ca/tv-show/crossroad-springs/season-1': 'V2',
	'/ca/tv-show/dci-banks/season-5': 'V3',
	'/ca/tv-show/buffy-the-vampire-slayer-season-8-motion-comic/season-1': 'V1',
	'/ca/tv-show/barney-miller/season-1': 'V2',
	'/ca/tv-show/below-deck/season-3': 'V3',
	'/ca/tv-show/21-jump-street/season-5': 'V1',
	'/ca/tv-show/beyond-times-gaze/season-1': 'V2',
	'/ca/tv-show/dci-banks/season-2': 'V3',
	'/ca/tv-show/amor-animal/season-1': 'V1',
	'/ca/tv-show/daria/season-3': 'V2',
	'/ca/tv-show/blue-ridge/season-1': 'V3',
	'/ca/tv-show/forensic-files/season-4': 'V1',
	'/ca/tv-show/caught-in-the-act-double-life/season-1': 'V2',
	'/ca/tv-show/galactik-football/season-2': 'V3',
	'/ca/tv-show/amnesia-2004/season-1': 'V1',
	'/ca/tv-show/borgia/season-3': 'V2',
	'/ca/tv-show/celebrity-iou/season-1': 'V3',
	'/ca/tv-show/be-cool-scooby-doo/season-1': 'V1',
	'/ca/tv-show/change-days/season-1': 'V2',
	'/ca/tv-show/dark-side-of-the-ring/season-4': 'V3',
	'/ca/tv-show/first-kill/season-1': 'V1',
	'/ca/tv-show/42-the-answer-to-almost-everything/season-1': 'V2',
	'/ca/tv-show/firefly-lane/season-2': 'V3',
	'/ca/tv-show/defiance/season-3': 'V1',
	'/ca/tv-show/amphibia/season-3': 'V2',
	'/ca/tv-show/angel/season-3': 'V3',
	'/ca/tv-show/dollhouse/season-1': 'V1',
	'/ca/tv-show/belgravia-the-next-chapter/season-1': 'V2',
	'/ca/tv-show/eureka/season-3': 'V3',
	'/ca/tv-show/darker-than-black/season-1': 'V1',
	'/ca/tv-show/a-woman-of-substance/season-3': 'V2',
	'/ca/tv-show/crossing-jordan/season-3': 'V3',
	'/ca/tv-show/betrothed-to-my-sisters-ex/season-1': 'V1',
	'/ca/tv-show/dave/season-3': 'V2',
	'/ca/tv-show/all-heart/season-1': 'V3',
	'/ca/tv-show/are-you-afraid-of-the-dark/season-1': 'V1',
	'/ca/tv-show/blue-planet-ii/season-1': 'V2',
	'/ca/tv-show/cells-at-work/season-2': 'V3',
	'/ca/tv-show/disenchantment/season-3': 'V1',
	'/ca/tv-show/benidorm/season-1': 'V2',
	'/ca/tv-show/fortitude/season-3': 'V3',
	'/ca/tv-show/below-deck/season-11': 'V1',
	'/ca/tv-show/belfort-and-lupin/season-1': 'V2',
	'/ca/tv-show/cometierra/season-1': 'V3',
	'/ca/tv-show/dickensian/season-1': 'V1',
	'/ca/tv-show/cherry-magic-thirty-years-of-virginity-can-make-you-a-wizard/season-1': 'V2',
	'/ca/tv-show/a-very-british-scandal/season-1': 'V3',
	'/ca/tv-show/elves-2021/season-1': 'V1',
	'/ca/tv-show/a-million-little-things/season-4': 'V2',
	'/ca/tv-show/ballers/season-4': 'V3',
	'/ca/tv-show/dramaworld/season-1': 'V1',
	'/ca/tv-show/expedition-x/season-5': 'V2',
	'/ca/tv-show/americas-funniest-home-videos/season-35': 'V3',
	'/ca/tv-show/dallas-1978/season-10': 'V1',
	'/ca/tv-show/according-to-jim/season-7': 'V2',
	'/ca/tv-show/bottom/season-2': 'V3',
	'/ca/tv-show/forensic-files/season-15': 'V1',
	'/ca/tv-show/embarrassing-bodies/season-4': 'V2',
	'/ca/tv-show/accused/season-2': 'V3',
	'/ca/tv-show/accident-suicide-or-murder/season-5': 'V1',
	'/ca/tv-show/american-dragon-jake-long/season-1': 'V2',
	'/ca/tv-show/beauty-and-the-beast/season-4': 'V3',
	'/ca/tv-show/free/season-1': 'V1',
	'/ca/tv-show/doctor-who-2013/season-13': 'V2',
	'/ca/tv-show/feel-good/season-1': 'V3',
	'/ca/tv-show/anthony-bourdain-parts-unknown/season-2': 'V1',
	'/ca/tv-show/bungo-stray-dogs/season-4': 'V2',
	'/ca/tv-show/below-deck/season-10': 'V3',
	'/ca/tv-show/face-a-face/season-3': 'V1',
	'/ca/tv-show/csi-miami/season-10': 'V2',
	'/ca/tv-show/damages/season-3': 'V3',
	'/ca/tv-show/anthony-bourdain-parts-unknown/season-5': 'V1',
	'/ca/tv-show/expedition-unknown/season-10': 'V2',
	'/ca/tv-show/blaze-and-the-monster-machines/season-3': 'V3',
	'/ca/tv-show/everybody-loves-raymond/season-2': 'V1',
	'/ca/tv-show/dennis-miller-live/season-1': 'V2',
	'/ca/tv-show/bordertown-2016/season-3': 'V3',
	'/ca/tv-show/cherif/season-2': 'V1',
	'/ca/tv-show/forensic-files/season-6': 'V2',
	'/ca/tv-show/dragon-ball-z-1989/season-11': 'V3',
	'/ca/tv-show/crashing-2017/season-1': 'V1',
	'/ca/tv-show/all-creatures-great-and-small/season-7': 'V2',
	'/ca/tv-show/dominion/season-1': 'V3',
	'/ca/tv-show/blaze-and-the-monster-machines/season-1': 'V1',
	'/ca/tv-show/bing/season-2': 'V2',
	'/ca/tv-show/faceoff-inside-the-nhl/season-2': 'V3',
	'/ca/tv-show/city-on-fire/season-1': 'V1',
	'/ca/tv-show/beyblade-metal-fusion/season-3': 'V2',
	'/ca/tv-show/emergency-1972/season-1': 'V3',
	'/ca/tv-show/dudes-2025/season-1': 'V1',
	'/ca/tv-show/from-dusk-till-dawn-the-series/season-1': 'V2',
	'/ca/tv-show/clannad/season-2': 'V3',
	'/ca/tv-show/amanda-and-alans-spanish-job/season-1': 'V1',
	'/ca/tv-show/code-lyoko/season-1': 'V2',
	'/ca/tv-show/familiar-wife/season-1': 'V3',
	'/ca/tv-show/being-human-2011/season-4': 'V1',
	'/ca/tv-show/f-is-for-family/season-5': 'V2',
	'/ca/tv-show/air-disasters/season-8': 'V3',
	'/ca/tv-show/dragons-the-nine-realms/season-3': 'V1',
	'/ca/tv-show/air-disasters/season-5': 'V2',
	'/ca/tv-show/anthony-bourdain-parts-unknown/season-9': 'V3',
	'/ca/tv-show/doc-mcstuffins/season-1': 'V1',
	'/ca/tv-show/blood-ties/season-1': 'V2',
	'/ca/tv-show/from-now-on-showtime/season-1': 'V3',
	'/ca/tv-show/faith/season-1': 'V1',
	'/ca/tv-show/ben-10-reboot/season-1': 'V2',
	'/ca/tv-show/dimension-404/season-1': 'V3',
	'/ca/tv-show/big-timber/season-3': 'V1',
	'/ca/tv-show/bob-abishola/season-5': 'V2',
	'/ca/tv-show/anthony-bourdain-parts-unknown/season-7': 'V3',
	'/ca/tv-show/fireman-sam/season-15': 'V1',
	'/ca/tv-show/bleach/season-9': 'V2',
	'/ca/tv-show/air-disasters/season-18': 'V3',
	'/ca/tv-show/foyles-war/season-8': 'V1',
	'/ca/tv-show/coupling/season-1': 'V2',
	'/ca/tv-show/48-hours/season-37': 'V3',
	'/ca/tv-show/boy-swallows-universe/season-1': 'V1',
	'/ca/tv-show/eva-lasting/season-2': 'V2',
	'/ca/tv-show/below-deck/season-6': 'V3',
	'/ca/tv-show/creepshow/season-3': 'V1',
	'/ca/tv-show/franklin-and-bash/season-4': 'V2',
	'/ca/tv-show/entourage/season-7': 'V3',
	'/ca/tv-show/beckham/season-1': 'V1',
	'/ca/tv-show/90-day-fiance-happily-ever-after/season-8': 'V2',
	'/ca/tv-show/catching-killers/season-2': 'V3',
	'/ca/tv-show/eastenders/season-1': 'V1',
	'/ca/tv-show/dark-city-the-cleaner/season-1': 'V2',
	'/ca/tv-show/below-deck-adventure/season-1': 'V3',
	'/ca/tv-show/fear-itself/season-1': 'V1',
	'/ca/tv-show/a-pup-named-scooby-doo/season-1': 'V2',
	'/ca/tv-show/expedition-unknown/season-15': 'V3',
	'/ca/tv-show/agatha-christie-lucy-worsley-on-the-mystery-queen/season-1': 'V1',
	'/ca/tv-show/dreamworks-how-to-train-your-dragon-legends/season-1': 'V2',
	'/ca/tv-show/full-circle-2023/season-1': 'V3',
	'/ca/tv-show/forensics-the-real-csi/season-1': 'V1',
	'/ca/tv-show/critter-fixers-country-vets/season-5': 'V2',
	'/ca/tv-show/famalam/season-1': 'V3',
	'/ca/tv-show/behzat-c-bir-ankara-polisiyesi/season-1': 'V1',
	'/ca/tv-show/48-hours/season-30': 'V2',
	'/ca/tv-show/daniel-tigers-neighborhood/season-2': 'V3',
	'/ca/tv-show/flight-of-the-conchords/season-2': 'V1',
	'/ca/tv-show/air-disasters/season-2': 'V2',
	'/ca/tv-show/forensic-files/season-2': 'V3',
	'/ca/tv-show/arde-madrid/season-1': 'V1',
	'/ca/tv-show/forensics-the-real-csi/season-4': 'V2',
	'/ca/tv-show/emergency-1972/season-6': 'V3',
	'/ca/tv-show/alistair-macleans-air-force-one-is-down/season-1': 'V1',
	'/ca/tv-show/allo-allo/season-4': 'V2',
	'/ca/tv-show/deadliest-catch/season-20': 'V3',
	'/ca/tv-show/below-deck-sailing-yacht/season-3': 'V1',
	'/ca/tv-show/gaslit/season-1': 'V2',
	'/ca/tv-show/air-disasters/season-11': 'V3',
	'/ca/tv-show/full-time-magister/season-1': 'V1',
	'/ca/tv-show/ballers/season-1': 'V2',
	'/ca/tv-show/cosmos-possible-worlds/season-1': 'V3',
	'/ca/tv-show/fbi-true/season-8': 'V1',
	'/ca/tv-show/an-idiot-abroad/season-3': 'V2',
	'/ca/tv-show/bandish-bandits/season-1': 'V3',
	'/ca/tv-show/family-business/season-1': 'V1',
	'/ca/tv-show/flcl/season-2': 'V2',
	'/ca/tv-show/dancing-on-the-edge/season-1': 'V3',
	'/ca/tv-show/air-disasters/season-10': 'V1',
	'/ca/tv-show/central-park/season-1': 'V2',
	'/ca/tv-show/diners-drive-ins-and-dives/season-54': 'V3',
	'/ca/tv-show/crooks/season-1': 'V1',
	'/ca/tv-show/digging-for-britain/season-9': 'V2',
	'/ca/tv-show/back-to-life/season-2': 'V3',
	'/ca/tv-show/daybreak/season-1': 'V1',
	'/ca/tv-show/divided-we-stand/season-1': 'V2',
	'/ca/tv-show/forensic-files/season-9': 'V3',
	'/ca/tv-show/contraband-seized-at-sea/season-1': 'V1',
	'/ca/tv-show/forensics-the-real-csi/season-2': 'V2',
	'/ca/tv-show/doctor-who-2013/season-25': 'V3',
	'/ca/tv-show/attack-on-london-hunting-the-7-7-bombers/season-1': 'V1',
	'/ca/tv-show/chesapeake-shores/season-6': 'V2',
	'/ca/tv-show/enlightened/season-1': 'V3',
	'/ca/tv-show/au-service-de-la-france/season-1': 'V1',
	'/ca/tv-show/big-time-rush/season-4': 'V2',
	'/ca/tv-show/bottom/season-3': 'V3',
	'/ca/tv-show/apocalypse-the-second-world-war/season-2': 'V1',
	'/ca/tv-show/animaniacs/season-4': 'V2',
	'/ca/tv-show/digimon-adventure-tri/season-1': 'V3',
	'/ca/tv-show/balance-a-perimenopause-journey/season-1': 'V1',
	'/ca/tv-show/cult-massacre-one-day-in-jonestown/season-1': 'V2',
	'/ca/tv-show/beyond-skinwalker-ranch/season-3': 'V3',
	'/ca/tv-show/below-deck-sailing-yacht/season-5': 'V1',
	'/ca/tv-show/dark-side-of-the-ring-after-dark/season-1': 'V2',
	'/ca/tv-show/csi-miami/season-7': 'V3',
	'/ca/tv-show/black-butler/season-3': 'V1',
	'/ca/tv-show/fresh-meat/season-4': 'V2',
	'/ca/tv-show/baby-daddy/season-2': 'V3',
	'/ca/tv-show/baby/season-2': 'V1',
	'/ca/tv-show/american-murder-gabby-petito/season-1': 'V2',
	'/ca/tv-show/a-terrified-teacher-at-ghoul-school/season-1': 'V3',
	'/ca/tv-show/bts-in-the-soop/season-1': 'V1',
	'/ca/tv-show/close-enough/season-1': 'V2',
	'/ca/tv-show/coffee-and-vanilla/season-1': 'V3',
	'/ca/tv-show/disney-gallery-the-mandalorian/season-1': 'V1',
	'/ca/tv-show/gargantia-on-the-verdurous-planet/season-1': 'V2',
	'/ca/tv-show/agatha-raisin/season-4': 'V3',
	'/ca/tv-show/alex-hugo/season-3': 'V1',
	'/ca/tv-show/class-of-09/season-1': 'V2',
	'/ca/tv-show/drifters-2016/season-1': 'V3',
	'/ca/tv-show/chez-maupassant/season-3': 'V1',
	'/ca/tv-show/air-disasters/season-14': 'V2',
	'/ca/tv-show/animals/season-1': 'V3',
	'/ca/tv-show/disenchantment/season-1': 'V1',
	'/ca/tv-show/as-we-see-it/season-1': 'V2',
	'/ca/tv-show/friends-from-college/season-1': 'V3',
	'/ca/tv-show/foods-greatest-hits/season-1': 'V1',
	'/ca/tv-show/24-india/season-1': 'V2',
	'/ca/tv-show/boy-meets-world/season-6': 'V3',
	'/ca/tv-show/dragons-race-to-the-edge/season-4': 'V1',
	'/ca/tv-show/below-deck/season-7': 'V2',
	'/ca/tv-show/changing-ends/season-1': 'V3',
	'/ca/tv-show/a-couple-of-cuckoos/season-2': 'V1',
	'/ca/tv-show/game-theory/season-12': 'V2',
	'/ca/tv-show/clark/season-1': 'V3',
	'/ca/tv-show/black-butler/season-4': 'V1',
	'/ca/tv-show/as-a-reincarnated-aristocrat-ill-use-my-appraisal-skill-to-rise-in-the-world-2024/season-1': 'V2',
	'/ca/tv-show/ghost-adventures/season-25': 'V3',
	'/ca/tv-show/art-of-crime/season-2': 'V1',
	'/ca/tv-show/better-things/season-5': 'V2',
	'/ca/tv-show/blinded/season-1': 'V3',
	'/ca/tv-show/dci-banks/season-3': 'V1',
	'/ca/tv-show/ally-mcbeal/season-5': 'V2',
	'/ca/tv-show/dong-yi/season-1': 'V3',
	'/ca/tv-show/coming-soon/season-1': 'V1',
	'/ca/tv-show/five-days/season-2': 'V2',
	'/ca/tv-show/a-small-light/season-1': 'V3',
	'/ca/tv-show/boris/season-3': 'V1',
	'/ca/tv-show/a-difficult-woman/season-1': 'V2',
	'/ca/tv-show/fantastic-four/season-2': 'V3',
	'/ca/tv-show/cougar-town/season-2': 'V1',
	'/ca/tv-show/american-monster/season-12': 'V2',
	'/ca/tv-show/are-you-the-one/season-8': 'V3',
	'/ca/tv-show/alice-nevers-le-juge-est-une-femme/season-5': 'V1',
	'/ca/tv-show/cardinal/season-4': 'V2',
	'/ca/tv-show/felicity/season-4': 'V3',
	'/ca/tv-show/ashes-to-ashes/season-1': 'V1',
	'/ca/tv-show/anthony-bourdain-no-reservations/season-3': 'V2',
	'/ca/tv-show/blue-water-high/season-2': 'V3',
	'/ca/tv-show/dave/season-1': 'V1',
	'/ca/tv-show/24-india/season-2': 'V2',
	'/ca/tv-show/chewing-gum/season-2': 'V3',
	'/ca/tv-show/fantasy-island-2021/season-2': 'V1',
	'/ca/tv-show/amy-bradley-is-missing/season-1': 'V2',
	'/ca/tv-show/a-girl-and-an-astronaut/season-1': 'V3',
	'/ca/tv-show/destinations-of-the-damned-with-zak-bagans/season-1': 'V1',
	'/ca/tv-show/a-haunting/season-9': 'V2',
	'/ca/tv-show/captivating-the-king/season-1': 'V3',
	'/ca/tv-show/all-rise/season-3': 'V1',
	'/ca/tv-show/dora-the-explorer/season-4': 'V2',
	'/ca/tv-show/danganronpa-3-the-end-of-hopes-peak-high-school/season-1': 'V3',
	'/ca/tv-show/a-real-bugs-life/season-2': 'V1',
	'/ca/tv-show/around-the-world-with-willy-fog/season-1': 'V2',
	'/ca/tv-show/arsenal-military-academy/season-1': 'V3',
	'/ca/tv-show/bad-education/season-4': 'V1',
	'/ca/tv-show/el-internado/season-2': 'V2',
	'/ca/tv-show/breathe/season-1': 'V3',
	'/ca/tv-show/gargoyles/season-2': 'V1',
	'/ca/tv-show/braquo/season-1': 'V2',
	'/ca/tv-show/age-of-youth/season-1': 'V3',
	'/ca/tv-show/explained/season-1': 'V1',
	'/ca/tv-show/daily-dose-of-sunshine/season-1': 'V2',
	'/ca/tv-show/forensic-files/season-14': 'V3',
	'/ca/tv-show/awkward/season-4': 'V1',
	'/ca/tv-show/according-to-jim/season-5': 'V2',
	'/ca/tv-show/family-business/season-2': 'V3',
	'/ca/tv-show/dinotopia/season-1': 'V1',
	'/ca/tv-show/alex-vs-america/season-5': 'V2',
	'/ca/tv-show/bitten/season-3': 'V3',
	'/ca/tv-show/born-again/season-1': 'V1',
	'/ca/tv-show/angels-in-america/season-1': 'V2',
	'/ca/tv-show/fit-for-tv-the-reality-of-the-biggest-loser/season-1': 'V3',
	'/ca/tv-show/altes-geld/season-1': 'V1',
	'/ca/tv-show/antiques-roadshow-1979/season-48': 'V2',
	'/ca/tv-show/cagney-and-lacey/season-4': 'V3',
	'/ca/tv-show/90-day-fiance-the-other-way/season-5': 'V1',
	'/ca/tv-show/being-human/season-4': 'V2',
	'/ca/tv-show/a-bit-of-fry-and-laurie/season-2': 'V3',
	'/ca/tv-show/born-to-kill-2005/season-2': 'V1',
	'/ca/tv-show/booked-first-day-in/season-3': 'V2',
	'/ca/tv-show/derailment/season-1': 'V3',
	'/ca/tv-show/broad-city/season-4': 'V1',
	'/ca/tv-show/between-two-ferns-with-zach-galifianakis/season-1': 'V2',
	'/ca/tv-show/chez-maupassant/season-2': 'V3',
	'/ca/tv-show/americas-test-kitchen/season-20': 'V1',
	'/ca/tv-show/el-silencio/season-1': 'V2',
	'/ca/tv-show/equestria-girls-tales-of-canterlot-high/season-1': 'V3',
	'/ca/tv-show/anthony-bourdain-parts-unknown/season-6': 'V1',
	'/ca/tv-show/birdie-buddy/season-1': 'V2',
	'/ca/tv-show/below-deck/season-5': 'V3',
	'/ca/tv-show/anthony-bourdain-no-reservations/season-4': 'V1',
	'/ca/tv-show/cry-wolf/season-1': 'V2',
	'/ca/tv-show/born-to-kill-2005/season-3': 'V3',
	'/ca/tv-show/adhura/season-1': 'V1',
	'/ca/tv-show/farmer-wants-a-wife/season-3': 'V2',
	'/ca/tv-show/broad-city/season-5': 'V3',
	'/ca/tv-show/divorce/season-2': 'V1',
	'/ca/tv-show/being-erica/season-1': 'V2',
	'/ca/tv-show/flipping-bangers/season-1': 'V3',
	'/ca/tv-show/father-brown-2013/season-1': 'V1',
	'/ca/tv-show/as-the-crow-flies/season-2': 'V2',
	'/ca/tv-show/ballmastrz-9009/season-1': 'V3',
	'/ca/tv-show/ambulance-australia/season-5': 'V1',
	'/ca/tv-show/bad-girls-club/season-1': 'V2',
	'/ca/tv-show/19-2/season-4': 'V3',
	'/ca/tv-show/date-with-the-angels/season-1': 'V1',
	'/ca/tv-show/fingersmith/season-1': 'V2',
	'/ca/tv-show/doctor-elise-the-royal-lady-with-the-lamp/season-1': 'V3',
	'/ca/tv-show/franklin-and-bash/season-1': 'V1',
	'/ca/tv-show/dinner-mate/season-1': 'V2',
	'/ca/tv-show/full-house/season-3': 'V3',
	'/ca/tv-show/expedition-unknown/season-13': 'V1',
	'/ca/tv-show/back-to-life/season-1': 'V2',
	'/ca/tv-show/a-killer-paradox/season-1': 'V3',
	'/ca/tv-show/anthony-bourdain-no-reservations/season-8': 'V1',
	'/ca/tv-show/delete-me/season-1': 'V2',
	'/ca/tv-show/expedition-x/season-9': 'V3',
	'/ca/tv-show/cold-case-who-killed-jonbenet-ramsey/season-1': 'V1',
	'/ca/tv-show/air-disasters/season-3': 'V2',
	'/ca/tv-show/ai-football-ggo/season-2': 'V3',
	'/ca/tv-show/everything-now/season-1': 'V1',
	'/ca/tv-show/air-disasters/season-15': 'V2',
	'/ca/tv-show/code-404/season-1': 'V3',
	'/ca/tv-show/agatha-christies-miss-marple/season-1': 'V1',
	'/ca/tv-show/1000-lb-sisters/season-5': 'V2',
	'/ca/tv-show/dollface/season-1': 'V3',
	'/ca/tv-show/astra-lost-in-space/season-1': 'V1',
	'/ca/tv-show/are-you-afraid-of-the-dark-2019/season-1': 'V2',
	'/ca/tv-show/doom-at-your-service-2021/season-1': 'V3',
	'/ca/tv-show/danganronpa-3-the-end-of-hopes-peak-high-school/season-3': 'V1',
	'/ca/tv-show/gasaraki/season-1': 'V2',
	'/ca/tv-show/bottom/season-1': 'V3',
	'/ca/tv-show/bakugan-battle-planet/season-1': 'V1',
	'/ca/tv-show/cocaine-quarterback-signal-caller-for-the-cartel/season-1': 'V2',
	'/ca/tv-show/cafe-minamdang/season-1': 'V3',
	'/ca/tv-show/alexander-the-making-of-a-god/season-1': 'V1',
	'/ca/tv-show/barney-and-friends/season-1': 'V2',
	'/ca/tv-show/doctor-who-2013/season-18': 'V3',
	'/ca/tv-show/blunt-talk/season-1': 'V1',
	'/ca/tv-show/engineering-catastrophes/season-1': 'V2',
	'/ca/tv-show/eva-lasting/season-3': 'V3',
	'/ca/tv-show/allen-iv3rson/season-1': 'V1',
	'/ca/tv-show/according-to-jim/season-2': 'V2',
	'/ca/tv-show/antiques-road-trip/season-4': 'V3',
	'/ca/tv-show/blues-clues/season-1': 'V1',
	'/ca/tv-show/breathe-in-breathe-out/season-1': 'V2',
	'/ca/tv-show/beyblade-burst/season-7': 'V3',
	'/ca/tv-show/apple-and-onion/season-2': 'V1',
	'/ca/tv-show/car-s-o-s/season-12': 'V2',
	'/ca/tv-show/bluey-minisodes/season-1': 'V3',
	'/ca/tv-show/army-wives/season-1': 'V1',
	'/ca/tv-show/frisky-dingo/season-1': 'V2',
	'/ca/tv-show/eat-st/season-3': 'V3',
	'/ca/tv-show/boss-and-me/season-1': 'V1',
	'/ca/tv-show/down-to-earth-with-zac-efron/season-2': 'V2',
	'/ca/tv-show/alex-hugo/season-5': 'V3',
	'/ca/tv-show/breath-of-fire/season-1': 'V1',
	'/ca/tv-show/all-creatures-great-and-small/season-5': 'V2',
	'/ca/tv-show/do-you-wanna-partner/season-1': 'V3',
	'/ca/tv-show/blindspotting/season-1': 'V1',
	'/ca/tv-show/cagney-and-lacey/season-1': 'V2',
	'/ca/tv-show/black-butterflies/season-1': 'V3',
	'/ca/tv-show/balthazar/season-5': 'V1',
	'/ca/tv-show/cats-eye/season-2': 'V2',
	'/ca/tv-show/a-real-bugs-life/season-1': 'V3',
	'/ca/tv-show/dragon-hunters/season-1': 'V1',
	'/ca/tv-show/days-of-our-lives/season-57': 'V2',
	'/ca/tv-show/black-lightning/season-3': 'V3',
	'/ca/tv-show/dr-pimple-popper/season-5': 'V1',
	'/ca/tv-show/beck/season-9': 'V2',
	'/ca/tv-show/f-troop/season-1': 'V3',
	'/ca/tv-show/catfish-the-tv-show/season-8': 'V1',
	'/ca/tv-show/black-comedy/season-2': 'V2',
	'/ca/tv-show/doctor-who-2013/season-24': 'V3',
	'/ca/tv-show/a-bloody-lucky-day/season-1': 'V1',
	'/ca/tv-show/caillou/season-1': 'V2',
	'/ca/tv-show/90-day-fiance-uk/season-2': 'V3',
	'/ca/tv-show/conversations-with-a-killer-the-son-of-sam-tapes/season-1': 'V1',
	'/ca/tv-show/black-sands/season-2': 'V2',
	'/ca/tv-show/a-certain-magical-index/season-2': 'V3',
	'/ca/tv-show/big-brother/season-23': 'V1',
	'/ca/tv-show/bat-masterson/season-1': 'V2',
	'/ca/tv-show/air-disasters/season-6': 'V3',
	'/ca/tv-show/american-detective-with-lt-joe-kenda/season-1': 'V1',
	'/ca/tv-show/doogie-howser-m-d/season-1': 'V2',
	'/ca/tv-show/evil-lives-here-shadows-of-death/season-3': 'V3',
	'/ca/tv-show/1000-ways-to-die/season-4': 'V1',
	'/ca/tv-show/fate-extra-last-encore/season-1': 'V2',
	'/ca/tv-show/clique/season-2': 'V3',
	'/ca/tv-show/according-to-jim/season-8': 'V1',
	'/ca/tv-show/darby-and-joan/season-2': 'V2',
	'/ca/tv-show/aldnoah-zero/season-1': 'V3',
	'/ca/tv-show/expedition-unknown/season-12': 'V1',
	'/ca/tv-show/dark-angel/season-1': 'V2',
	'/ca/tv-show/fame/season-1': 'V3',
	'/ca/tv-show/drag-race-espana/season-5': 'V1',
	'/ca/tv-show/bad-teacher/season-1': 'V2',
	'/ca/tv-show/fosse-verdon/season-1': 'V3',
	'/ca/tv-show/four-years-later/season-1': 'V1',
	'/ca/tv-show/freakazoid/season-1': 'V2',
	'/ca/tv-show/chastity-high/season-1': 'V3',
	'/ca/tv-show/adventures-of-superman/season-5': 'V1',
	'/ca/tv-show/blues-clues-and-you/season-5': 'V2',
	'/ca/tv-show/are-you-the-one/season-7': 'V3',
	'/ca/tv-show/full-custom-garage/season-8': 'V1',
	'/ca/tv-show/brothers-and-sisters-2006/season-5': 'V2',
	'/ca/tv-show/estonia-a-find-that-changes-everything/season-1': 'V3',
	'/ca/tv-show/damnation/season-1': 'V1',
	'/ca/tv-show/furia/season-2': 'V2',
	'/ca/tv-show/deep-water-2019/season-1': 'V3',
	'/ca/tv-show/devilsdorp/season-1': 'V1',
	'/ca/tv-show/daily-lives-of-high-school-boys/season-1': 'V2',
	'/ca/tv-show/fireflies/season-1': 'V3',
	'/ca/tv-show/femme-fatales/season-1': 'V1',
	'/ca/tv-show/16-and-pregnant/season-1': 'V2',
	'/ca/tv-show/army-wives/season-2': 'V3',
	'/ca/tv-show/ambulance/season-5': 'V1',
	'/ca/tv-show/aggretsuko/season-5': 'V2',
	'/ca/tv-show/ancient-egypt-by-train/season-1': 'V3',
	'/ca/tv-show/blues-clues-and-you/season-4': 'V1',
	'/ca/tv-show/dogtanian-and-the-three-muskehounds/season-1': 'V2',
	'/ca/tv-show/a-very-british-yule-log/season-1': 'V3',
	'/ca/tv-show/a-condition-called-love/season-1': 'V1',
	'/ca/tv-show/body-cam/season-5': 'V2',
	'/ca/tv-show/dna-nl/season-1': 'V3',
	'/ca/tv-show/elite-short-stories-carla-samuel/season-1': 'V1',
	'/ca/tv-show/fixer-upper/season-1': 'V2',
	'/ca/tv-show/brotherhood/season-2': 'V3',
	'/ca/tv-show/dark-side-of-the-90s/season-3': 'V1',
	'/ca/tv-show/bob-the-builder/season-1': 'V2',
	'/ca/tv-show/expedition-unknown/season-3': 'V3',
	'/ca/tv-show/di4ri/season-2': 'V1',
	'/ca/tv-show/einstein/season-1': 'V2',
	'/ca/tv-show/containment/season-1': 'V3',
	'/ca/tv-show/father-matthew/season-5': 'V1',
	'/ca/tv-show/food-paradise/season-1': 'V2',
	'/ca/tv-show/avalon-tv/season-1': 'V3',
	'/ca/tv-show/bugtime-adventures/season-1': 'V1',
	'/ca/tv-show/dragons-race-to-the-edge/season-3': 'V2',
	'/ca/tv-show/charles-in-charge/season-1': 'V3',
	'/ca/tv-show/black-monday/season-1': 'V1',
	'/ca/tv-show/air-disasters/season-13': 'V2',
	'/ca/tv-show/car-s-o-s/season-10': 'V3',
	'/ca/tv-show/beavis-and-butt-head/season-3': 'V1',
	'/ca/tv-show/doubt-2024/season-1': 'V2',
	'/ca/tv-show/bakugan-battle-planet/season-5': 'V3',
	'/ca/tv-show/deadliest-catch/season-8': 'V1',
	'/ca/tv-show/beck/season-8': 'V2',
	'/ca/tv-show/black-jesus/season-1': 'V3',
	'/ca/tv-show/a-french-village/season-3': 'V1',
	'/ca/tv-show/disneys-adventures-of-the-gummi-bears/season-1': 'V2',
	'/ca/tv-show/false-identity/season-1': 'V3',
	'/ca/tv-show/chronicles-of-the-sun/season-1': 'V1',
	'/ca/tv-show/army-wives/season-7': 'V2',
	'/ca/tv-show/fast-n-loud/season-2': 'V3',
	'/ca/tv-show/elkhorn/season-1': 'V1',
	'/ca/tv-show/1000-ways-to-die/season-1': 'V2',
	'/ca/tv-show/better-call-saul-presents-slippin-jimmy/season-1': 'V3',
	'/ca/tv-show/el-cid/season-2': 'V1',
	'/ca/tv-show/cristo-y-rey/season-1': 'V2',
	'/ca/tv-show/apple-and-onion/season-1': 'V3',
	'/ca/tv-show/an-idiot-abroad/season-2': 'V1',
	'/ca/tv-show/are-you-being-served/season-1': 'V2',
	'/ca/tv-show/bitten/season-2': 'V3',
	'/ca/tv-show/dallas/season-1': 'V1',
	'/ca/tv-show/body-cam/season-6': 'V2',
	'/ca/tv-show/bergerac/season-1': 'V3',
	'/ca/tv-show/caught-on-bodycam/season-1': 'V1',
	'/ca/tv-show/canaan/season-1': 'V2',
	'/ca/tv-show/abby-hatcher/season-1': 'V3',
	'/ca/tv-show/bella-germania/season-1': 'V1',
	'/ca/tv-show/forged-in-fire/season-8': 'V2',
	'/ca/tv-show/bad-blood-2017/season-1': 'V3',
	'/ca/tv-show/dupur-thakurpo/season-1': 'V1',
	'/ca/tv-show/ancient-worlds/season-1': 'V2',
	'/ca/tv-show/get-krack-n/season-2': 'V3',
	'/ca/tv-show/buried-in-the-backyard/season-4': 'V1',
	'/ca/tv-show/absolutely-fabulous/season-5': 'V2',
	'/ca/tv-show/four-more-shots-please/season-3': 'V3',
	'/ca/tv-show/buried-in-the-backyard/season-5': 'V1',
	'/ca/tv-show/evermoor/season-1': 'V2',
	'/ca/tv-show/borderline-2017/season-1': 'V3',
	'/ca/tv-show/bakuman/season-1': 'V1',
	'/ca/tv-show/deep-state/season-2': 'V2',
	'/ca/tv-show/dallas-cowboys-cheerleaders-making-the-team/season-1': 'V3',
	'/ca/tv-show/american-crime/season-2': 'V1',
	'/ca/tv-show/a-galaxy-next-door/season-1': 'V2',
	'/ca/tv-show/ainori-love-wagon-asian-journey/season-1': 'V3',
	'/ca/tv-show/customer-wars/season-8': 'V1',
	'/ca/tv-show/gangland-undercover/season-2': 'V2',
	'/ca/tv-show/four-weddings/season-1': 'V3',
	'/ca/tv-show/extreme-sisters/season-1': 'V1',
	'/ca/tv-show/ex-wives-of-rock/season-1': 'V2',
	'/ca/tv-show/dead-mount-death-play/season-1': 'V3',
	'/ca/tv-show/cagney-and-lacey/season-7': 'V1',
	'/ca/tv-show/800-words/season-2': 'V2',
	'/ca/tv-show/blade-of-the-immortal-2019/season-1': 'V3',
	'/ca/tv-show/family-matters/season-2': 'V1',
	'/ca/tv-show/bar-rescue/season-5': 'V2',
	'/ca/tv-show/culte/season-1': 'V3',
	'/ca/tv-show/bizarre-er/season-1': 'V1',
	'/ca/tv-show/boboiboy-galaxy/season-1': 'V2',
	'/ca/tv-show/forbidden-love/season-1': 'V3',
	'/ca/tv-show/blippi-wonders/season-1': 'V1',
	'/ca/tv-show/a-certain-magical-index/season-3': 'V2',
	'/ca/tv-show/absolutely-fabulous/season-6': 'V3',
	'/ca/tv-show/beck/season-7': 'V1',
	'/ca/tv-show/better-call-saul-los-pollos-hermanos-employee-training/season-3': 'V2',
	'/ca/tv-show/crimes-that-shook-australia/season-3': 'V3',
	'/ca/tv-show/ghost-2012/season-1': 'V1',
	'/ca/tv-show/donde-esta-marta/season-1': 'V2',
	'/ca/tv-show/eagleheart/season-1': 'V3',
	'/ca/tv-show/dreaming-whilst-black/season-1': 'V1',
	'/ca/tv-show/dream-high/season-1': 'V2',
	'/ca/tv-show/chihayafuru/season-2': 'V3',
	'/ca/tv-show/abby-hatcher/season-2': 'V1',
	'/ca/tv-show/allen-v-farrow/season-1': 'V2',
	'/ca/tv-show/bad-girls-club/season-10': 'V3',
	'/ca/tv-show/alex-hugo/season-4': 'V1',
	'/ca/tv-show/chopped/season-14': 'V2',
	'/ca/tv-show/dead-of-night-2013/season-1': 'V3',
	'/ca/tv-show/crossfire/season-1': 'V1',
	'/ca/tv-show/braquo/season-2': 'V2',
	'/ca/tv-show/departures/season-1': 'V3',
	'/ca/tv-show/armitage-iii/season-1': 'V1',
	'/ca/tv-show/danny-will-die-alone/season-1': 'V2',
	'/ca/tv-show/clone-high-2023/season-1': 'V3',
	'/ca/tv-show/cinderella-game/season-1': 'V1',
	'/ca/tv-show/dear-white-people/season-4': 'V2',
	'/ca/tv-show/diffrent-strokes/season-1': 'V3',
	'/ca/tv-show/chris-tarrant-extreme-railways/season-1': 'V1',
	'/ca/tv-show/el-secretario/season-1': 'V2',
	'/ca/tv-show/coegangyagu/season-1': 'V3',
	'/ca/tv-show/fixer-upper/season-4': 'V1',
	'/ca/tv-show/degrassi-next-class/season-1': 'V2',
	'/ca/tv-show/corner-gas-animated/season-1': 'V3',
	'/ca/tv-show/face-off/season-10': 'V1',
	'/ca/tv-show/gator-boys/season-1': 'V2',
	'/ca/tv-show/dog-whisperer/season-8': 'V3',
	'/ca/tv-show/flames/season-2': 'V1',
	'/ca/tv-show/city-of-dreams/season-1': 'V2',
	'/ca/tv-show/chefs-table-france/season-1': 'V3',
	'/ca/tv-show/betaal/season-1': 'V1',
	'/ca/tv-show/buba/season-2': 'V2',
	'/ca/tv-show/bad-education/season-1': 'V3',
	'/ca/tv-show/dr-seusss-red-fish-blue-fish/season-2': 'V1',
	'/ca/tv-show/bake-squad/season-2': 'V2',
	'/ca/tv-show/doctor-thorne/season-1': 'V3',
	'/ca/tv-show/being-erica/season-4': 'V1',
	'/ca/tv-show/chasing-life/season-1': 'V2',
	'/ca/tv-show/cheaters/season-21': 'V3',
	'/ca/tv-show/apple-and-onion/season-3': 'V1',
	'/ca/tv-show/ghost-force/season-1': 'V2',
	'/ca/tv-show/bad-blood-2017/season-2': 'V3',
	'/ca/tv-show/ekaterina/season-2': 'V1',
	'/ca/tv-show/catfish-the-tv-show/season-7': 'V2',
	'/ca/tv-show/days/season-1': 'V3',
	'/ca/tv-show/ensam-hemma/season-1': 'V1',
	'/ca/tv-show/ainori-love-wagon-african-journey/season-1': 'V2',
	'/ca/tv-show/ainori-love-wagon-asian-journey/season-2': 'V3',
	'/ca/tv-show/buried-in-the-backyard/season-3': 'V1',
	'/ca/tv-show/fear-thy-neighbor/season-4': 'V2',
	'/ca/tv-show/bucchigiri/season-1': 'V3',
	'/ca/tv-show/business-as-usual/season-1': 'V1',
	'/ca/tv-show/aussie-gold-hunters/season-1': 'V2',
	'/ca/tv-show/big-block-singsong/season-1': 'V3',
	'/ca/tv-show/craig-of-the-creek/season-2': 'V1',
	'/ca/tv-show/ellies-real-good-food/season-2': 'V2',
	'/ca/tv-show/all-my-children/season-1': 'V3',
	'/ca/tv-show/dog-loves-books/season-1': 'V1',
	'/ca/tv-show/a-la-carte/season-1': 'V2',
	'/ca/tv-show/delocated/season-1': 'V3',
	'/ca/tv-show/cheaters/season-1': 'V1',
	'/ca/tv-show/food-paradise/season-3': 'V2',
	'/ca/tv-show/365-repeat-the-year/season-1': 'V3',
	'/ca/tv-show/cestvs-the-roman-fighter/season-1': 'V1',
	'/ca/tv-show/fear-thy-neighbor/season-11': 'V2',
	'/ca/tv-show/american-monster/season-7': 'V3',
	'/ca/tv-show/born-to-kill-2005/season-1': 'V1',
	'/ca/tv-show/ed-edd-n-eddy/season-5': 'V2',
	'/ca/tv-show/code-404/season-3': 'V3',
	'/ca/tv-show/der-kleine-drache-kokosnuss/season-1': 'V1',
	'/ca/tv-show/fancy-nancy/season-1': 'V2',
	'/ca/tv-show/celebrity-family-feud/season-11': 'V3',
	'/ca/tv-show/game-shakers/season-3': 'V1',
	'/ca/tv-show/crikey-its-the-irwins/season-1': 'V2',
	'/ca/tv-show/alternatino-with-arturo-castro-tv/season-1': 'V3',
	'/ca/tv-show/cocaine-air-smugglers-at-30-000-ft/season-1': 'V1',
	'/ca/tv-show/do-no-harm/season-1': 'V2',
	'/ca/tv-show/drag-heals/season-2': 'V3',
	'/ca/tv-show/chef-swap-at-the-beach/season-1': 'V1',
	'/ca/tv-show/alertes/season-1': 'V2',
	'/ca/tv-show/callan/season-1': 'V3',
	'/ca/tv-show/chrisley-knows-best/season-10': 'V1',
	'/ca/tv-show/chantal/season-2': 'V2',
	'/ca/tv-show/benson/season-2': 'V3',
	'/ca/tv-show/cheese-slices/season-1': 'V1',
	'/ca/tv-show/ambulance-australia/season-4': 'V2',
	'/ca/tv-show/can-ci-pin-fangzhu-xingkong/season-1': 'V3',
	'/ca/tv-show/bad-girlfriend/season-1': 'V1',
	'/ca/tv-show/conversations-with-a-killer-the-jeffrey-dahmer-tapes/season-1': 'V2',
	'/ca/tv-show/get-krack-n/season-1': 'V3',
	'/ca/tv-show/a-crime-to-remember/season-1': 'V1',
	'/ca/tv-show/100-wolf-legend-of-the-moonstone/season-1': 'V2',
	'/ca/tv-show/club-de-cuervos/season-1': 'V3',
	'/ca/tv-show/bloodride/season-1': 'V1',
	'/ca/tv-show/club-de-cuervos/season-3': 'V2',
	'/ca/tv-show/canadian-pickers/season-4': 'V3',
	'/ca/tv-show/crisis-in-six-scenes/season-1': 'V1',
	'/ca/tv-show/bad-girls-club/season-2': 'V2',
	'/ca/tv-show/do-do-sol-sol-la-la-sol/season-1': 'V3',
	'/ca/tv-show/bebefinn/season-1': 'V1',
	'/ca/tv-show/change-days/season-2': 'V2',
	'/ca/tv-show/corner-gas-animated/season-3': 'V3',
	'/ca/tv-show/a-kind-of-spark/season-2': 'V1',
	'/ca/tv-show/always-a-witch/season-1': 'V2',
	'/ca/tv-show/doctors-2000/season-22': 'V3',
	'/ca/tv-show/battle-through-the-heaven/season-1': 'V1',
	'/ca/tv-show/ballykissangel/season-6': 'V2',
	'/ca/tv-show/crash/season-1': 'V3',
	'/ca/tv-show/game-theory/season-11': 'V1',
	'/ca/tv-show/dateline/season-26': 'V2',
	'/ca/tv-show/becoming-frida-kahlo/season-1': 'V3',
	'/ca/tv-show/4minutes/season-1': 'V1',
	'/ca/tv-show/1000-ways-to-die/season-2': 'V2',
	'/ca/tv-show/escaping-utopia/season-1': 'V3',
	'/ca/tv-show/1000-lb-roomies/season-1': 'V1',
	'/ca/tv-show/a-criminal-affair/season-2': 'V2',
	'/ca/tv-show/ancient-x-files/season-1': 'V3',
	'/ca/tv-show/beyond-the-brush/season-1': 'V1',
	'/ca/tv-show/black-and-missing/season-1': 'V2',
	'/ca/tv-show/galactik-football/season-3': 'V3',
	'/ca/tv-show/bering-sea-gold/season-15': 'V1',
	'/ca/tv-show/24-hour-health-club/season-1': 'V2',
	'/ca/tv-show/beyblade-burst/season-6': 'V3',
	'/ca/tv-show/ashes-to-ashes/season-3': 'V1',
	'/ca/tv-show/blade-dance-of-elementalers/season-1': 'V2',
	'/ca/tv-show/celebrity-jeopardy/season-2': 'V3',
	'/ca/tv-show/braquo/season-4': 'V1',
	'/ca/tv-show/chief-of-staff/season-1': 'V2',
	'/ca/tv-show/bulletproof/season-1': 'V3',
	'/ca/tv-show/227/season-1': 'V1',
	'/ca/tv-show/fraggle-rock/season-4': 'V2',
	'/ca/tv-show/bakuman/season-2': 'V3',
	'/ca/tv-show/dragonar-academy/season-1': 'V1',
	'/ca/tv-show/edgemont/season-4': 'V2',
	'/ca/tv-show/dating-unlocked/season-1': 'V3',
	'/ca/tv-show/fatal-injections/season-1': 'V1',
	'/ca/tv-show/fboy-island/season-1': 'V2',
	'/ca/tv-show/camp-camp/season-1': 'V3',
	'/ca/tv-show/crikey-its-the-irwins/season-2': 'V1',
	'/ca/tv-show/game-theory/season-4': 'V2',
	'/ca/tv-show/a-to-z/season-1': 'V3',
	'/ca/tv-show/americas-test-kitchen/season-18': 'V1',
	'/ca/tv-show/1000-ways-to-die/season-3': 'V2',
	'/ca/tv-show/contraband-seized-at-the-border/season-1': 'V3',
	'/ca/tv-show/deadliest-journeys/season-2': 'V1',
	'/ca/tv-show/30-days-with-ryan-garcia/season-1': 'V2',
	'/ca/tv-show/alaska-state-troopers/season-1': 'V3',
	'/ca/tv-show/ane-log/season-1': 'V1',
	'/ca/tv-show/behind-the-white-tower/season-1': 'V2',
	'/ca/tv-show/brene-brown-atlas-of-the-heart/season-1': 'V3',
	'/ca/tv-show/eat-st/season-4': 'V1',
	'/ca/tv-show/evidence-of-murder/season-2': 'V2',
	'/ca/tv-show/extreme-homes/season-3': 'V3',
	'/ca/tv-show/football-parents/season-1': 'V1',
	'/ca/tv-show/george-carlins-american-dream/season-1': 'V2',
	'/ca/tv-show/akai-kodan-zillion/season-1': 'V3',
	'/ca/tv-show/1994/season-1': 'V1',
	'/ca/tv-show/cells-at-work-code-black/season-1': 'V2',
	'/ca/tv-show/au-service-de-la-france/season-2': 'V3',
	'/ca/tv-show/ghost-adventures/season-24': 'V1',
	'/ca/tv-show/blade-of-the-immortal/season-1': 'V2',
	'/ca/tv-show/body-bizarre/season-1': 'V3',
	'/ca/tv-show/dont-look-back-the-legend-of-orpheus/season-1': 'V1',
	'/ca/tv-show/fatal-vows/season-7': 'V2',
	'/ca/tv-show/four-weddings/season-8': 'V3',
	'/ca/tv-show/adventures-of-sonic-the-hedgehog/season-3': 'V1',
	'/ca/tv-show/fiasco/season-1': 'V2',
	'/ca/tv-show/fixer-upper/season-3': 'V3',
	'/ca/tv-show/dangerous-persuasions/season-1': 'V1',
	'/ca/tv-show/finding-bigfoot/season-3': 'V2',
	'/ca/tv-show/army-wives/season-6': 'V3',
	'/ca/tv-show/designated-survivor-60-days/season-1': 'V1',
	'/ca/tv-show/capitani/season-1': 'V2',
	'/ca/tv-show/cops/season-24': 'V3',
	'/ca/tv-show/family-matters/season-8': 'V1',
	'/ca/tv-show/fear-thy-neighbor/season-10': 'V2',
	'/ca/tv-show/first-blood/season-1': 'V3',
	'/ca/tv-show/about-sunday-night/season-1': 'V1',
	'/ca/tv-show/babies/season-1': 'V2',
	'/ca/tv-show/be-not-meant-to-be/season-1': 'V3',
	'/ca/tv-show/cosby/season-1': 'V1',
	'/ca/tv-show/dahab-ghali/season-1': 'V2',
	'/ca/tv-show/alaska-pd/season-1': 'V3',
	'/ca/tv-show/disney-gallery-the-mandalorian/season-2': 'V1',
	'/ca/tv-show/get-organized-with-the-home-edit/season-1': 'V2',
	'/ca/tv-show/carl-the-collector/season-1': 'V3',
	'/ca/tv-show/agent-raghav/season-1': 'V1',
	'/ca/tv-show/dragons-rescue-riders-heroes-of-the-sky/season-1': 'V2',
	'/ca/tv-show/64-zoo-lane/season-1': 'V3',
	'/ca/tv-show/a-la-poursuite-du-reve-glace/season-1': 'V1',
	'/ca/tv-show/four-weddings/season-4': 'V2',
	'/ca/tv-show/cesar-millan-better-human-better-dog/season-3': 'V3',
	'/ca/tv-show/bodybag-ohio-youngstown/season-2': 'V1',
	'/ca/tv-show/autopsy/season-1': 'V2',
	'/ca/tv-show/bad-girls-club/season-16': 'V3',
	'/ca/tv-show/fatal-vows/season-6': 'V1',
	'/ca/tv-show/antiques-roadshow-1979/season-47': 'V2',
	'/ca/tv-show/americas-test-kitchen/season-15': 'V3',
	'/ca/tv-show/entrapped-2022/season-1': 'V1',
	'/ca/tv-show/braceface/season-1': 'V2',
	'/ca/tv-show/conan/season-10': 'V3',
	'/ca/tv-show/food-paradise/season-13': 'V1',
	'/ca/tv-show/food-paradise/season-6': 'V2',
	'/ca/tv-show/four-weddings/season-5': 'V3',
	'/ca/tv-show/criminal-justice/season-2': 'V1',
	'/ca/tv-show/cagney-and-lacey/season-5': 'V2',
	'/ca/tv-show/four-in-the-morning/season-1': 'V3',
	'/ca/tv-show/floopaloo-where-are-you/season-2': 'V1',
	'/ca/tv-show/geckos-garage-3d/season-1': 'V2',
	'/ca/tv-show/doctor-who-2013/season-23': 'V3',
	'/ca/tv-show/g-i-joe-a-real-american-hero/season-1': 'V1',
	'/ca/tv-show/carl-the-collector/season-2': 'V2',
	'/ca/tv-show/dr-90210/season-1': 'V3',
	'/ca/tv-show/americas-got-talent/season-14': 'V1',
	'/ca/tv-show/cagney-and-lacey/season-3': 'V2',
	'/ca/tv-show/destination-truth/season-4': 'V3',
	'/ca/tv-show/food-party/season-1': 'V1',
	'/ca/tv-show/blackstone/season-4': 'V2',
	'/ca/tv-show/air-master/season-1': 'V3',
	'/ca/tv-show/bunnytown/season-1': 'V1',
	'/ca/tv-show/dr-phil/season-17': 'V2',
	'/ca/tv-show/forbidden-history/season-2': 'V3',
	'/ca/tv-show/chasing-shadows/season-1': 'V1',
	'/ca/tv-show/dark-shadows/season-2': 'V2',
	'/ca/tv-show/curious-traveler/season-4': 'V3',
	'/ca/tv-show/dance-champions/season-1': 'V1',
	'/ca/tv-show/deadlocked-how-america-shaped-the-supreme-court/season-1': 'V2',
	'/ca/tv-show/ai-hui-lai/season-1': 'V3',
	'/ca/tv-show/fear-thy-neighbor/season-3': 'V1',
	'/ca/tv-show/american-gladiators/season-7': 'V2',
	'/ca/tv-show/abby-hatcher/season-3': 'V3',
	'/ca/tv-show/class-of-92/season-1': 'V1',
	'/ca/tv-show/air-warriors/season-3': 'V2',
	'/ca/tv-show/aj-and-the-queen/season-1': 'V3',
	'/ca/tv-show/cops/season-25': 'V1',
	'/ca/tv-show/bebefinn/season-2': 'V2',
	'/ca/tv-show/born-to-kill-2005/season-4': 'V3',
	'/ca/tv-show/cinema-toast/season-1': 'V1',
	'/ca/tv-show/curses/season-1': 'V2',
	'/ca/tv-show/der-lack-ist-ab/season-2': 'V3',
	'/ca/tv-show/four-weddings/season-10': 'V1',
	'/ca/tv-show/deliver-me-2024/season-1': 'V2',
	'/ca/tv-show/barefoot-contessa/season-2': 'V3',
	'/ca/tv-show/crime-scene-the-texas-killing-fields/season-1': 'V1',
	'/ca/tv-show/frenemies/season-1': 'V2',
	'/ca/tv-show/7-little-johnstons/season-2': 'V3',
	'/ca/tv-show/agi-bagi/season-1': 'V1',
	'/ca/tv-show/americas-mississippi/season-1': 'V2',
	'/ca/tv-show/americas-test-kitchen/season-3': 'V3',
	'/ca/tv-show/army-wives/season-5': 'V1',
	'/ca/tv-show/b-king/season-1': 'V2',
	'/ca/tv-show/battles-bc/season-1': 'V3',
	'/ca/tv-show/blowing-up-history-2016/season-1': 'V1',
	'/ca/tv-show/borg-mom/season-1': 'V2',
	'/ca/tv-show/born-to-kill-2005/season-6': 'V3',
	'/ca/tv-show/brave-10/season-1': 'V1',
	'/ca/tv-show/bronx-zoo-90-crime-chaos-and-baseball/season-1': 'V2',
	'/ca/tv-show/brothers-conflict/season-1': 'V3',
	'/ca/tv-show/building-off-the-grid/season-8': 'V1',
	'/ca/tv-show/cancer-the-emperor-of-all-maladies/season-1': 'V2',
	'/ca/tv-show/christmas-cookie-challenge/season-4': 'V3',
	'/ca/tv-show/cops/season-21': 'V1',
	'/ca/tv-show/cops/season-23': 'V2',
	'/ca/tv-show/cops/season-26': 'V3',
	'/ca/tv-show/critter-fixers-country-vets/season-2': 'V1',
	'/ca/tv-show/curious-traveler/season-3': 'V2',
	'/ca/tv-show/curious-traveler/season-5': 'V3',
	'/ca/tv-show/der-lack-ist-ab/season-1': 'V1',
	'/ca/tv-show/dolly-partons-heartstrings/season-1': 'V2',
	'/ca/tv-show/ellies-real-good-food/season-1': 'V3',
	'/ca/tv-show/fantasista-doll/season-1': 'V1',
	'/ca/tv-show/fbi-true/season-7': 'V2',
	'/ca/tv-show/food-safari/season-2': 'V3',
	'/ca/tv-show/furiki-wheels/season-1': 'V1',
	'/ca/tv-show/cops/season-20': 'V2',
	'/ca/tv-show/all-saints/season-3': 'V3',
	'/ca/tv-show/au-secours-de-beatrice/season-4': 'V1',
	'/ca/tv-show/barefoot-contessa/season-10': 'V2',
	'/ca/tv-show/barefoot-contessa/season-11': 'V3',
	'/ca/tv-show/barefoot-contessa/season-13': 'V1',
	'/ca/tv-show/barefoot-contessa/season-14': 'V2',
	'/ca/tv-show/barefoot-contessa/season-15': 'V3',
	'/ca/tv-show/barefoot-contessa/season-17': 'V1',
	'/ca/tv-show/barefoot-contessa/season-18': 'V2',
	'/ca/tv-show/barefoot-contessa/season-19': 'V3',
	'/ca/tv-show/barefoot-contessa/season-5': 'V1',
	'/ca/tv-show/barefoot-contessa/season-6': 'V2',
	'/ca/tv-show/barefoot-contessa/season-8': 'V3',
	'/ca/tv-show/betty-boop/season-2': 'V1',
	'/ca/tv-show/camp-lakebottom/season-3': 'V2',
	'/ca/tv-show/cheaters/season-5': 'V3',
	'/ca/tv-show/derive/season-1': 'V1',
	'/ca/tv-show/eva-lasting/season-4': 'V2',
	'/ca/tv-show/fatal-attraction-2013/season-4': 'V3',
	'/ca/tv-show/food-safari/season-3': 'V1',
	'/ca/tv-show/food-safari/season-4': 'V2',
	'/ca/tv-show/fortier/season-1': 'V3',
};

export default metaDescriptionVariantTitles;
